// import { useEffect, useMemo, useState, useCallback, useRef } from 'react';
// import { Box, Typography, Button, CircularProgress, Paper, Grid, IconButton, Stack, Tooltip, Snackbar, Alert, Checkbox, Card, CardContent, Avatar, TextField, InputAdornment, Divider, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
// import DeleteIcon from '@mui/icons-material/Delete';
// import SearchIcon from '@mui/icons-material/Search';
// import { DataGrid } from '@mui/x-data-grid';
// import { useNavigate, Link } from 'react-router-dom';
// import axios from 'axios';
// import { FaUser } from 'react-icons/fa';
// import { VscNewFile } from 'react-icons/vsc';
// import { useMediaQuery, useTheme } from '@mui/material';
// import PdfViewer from '../components/PdfViewer';
// import { useAuth } from '../context/AuthContext';
// import DescriptionIcon from '@mui/icons-material/Description';
// import PersonIcon from '@mui/icons-material/Person';
// import PhoneIcon from '@mui/icons-material/Phone';
// import LinkIcon from '@mui/icons-material/Link';
// import { formatRows } from '../utils/formatRows';
// import NoDataComponent from '../components/NoDataComponent';
// import CustomNoDataOverlay from '../components/CustomNoDataOverlay';
// import CenterLoader from '../components/CenterLoader';

// const normalizeDate = (v) => typeof v === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(v) ? v.split('-').reverse().join('/') : v || '-';

// // Helper for avatar color and initials
// function stringToColor(string) {
//     let hash = 0;
//     for (let i = 0; i < string.length; i++) {
//         hash = string.charCodeAt(i) + ((hash << 5) - hash);
//     }
//     const colors = ['#e74c3c', '#3498db', '#2ecc71', '#e67e22', '#9b59b6', '#1abc9c', '#3f51b5', '#e91e63', '#795548', '#00bcd4'];
//     return colors[Math.abs(hash) % colors.length];
// }

// function getInitials(name) {
//     if (!name) return 'C';
//     return name.trim().charAt(0).toUpperCase();
// }

// export default function OrdersAdmin({ connectionString, pdfString }) {
//     const { user, selectedCompany } = useAuth();
//     const API_URL = `${connectionString}/api`;
//     const PDF_API_BASE = pdfString;
//     const userId = user?.UserId || null;
//     const companyId = selectedCompany?.CompId || null;
//     const role = user?.UserCategory;
//     const navigate = useNavigate();

//     const theme = useTheme();
//     const isDesktop = useMediaQuery(theme.breakpoints.up('md')); // ≥ md → DataGrid, < md → Cards

//     const [orders, setOrders] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [showPending, setShowPending] = useState(false);
//     const [pendingOrders, setPendingOrders] = useState([]);
//     const [loadingPending, setLoadingPending] = useState(false);
//     const [selectedRows, setSelectedRows] = useState([]);
//     const [selectedRowIds, setSelectedRowIds] = useState([]);
//     const [challanRows, setChallanRows] = useState([]);
//     const [challanLoading, setChallanLoading] = useState(true);
//     const [challanSelectionModel, setChallanSelectionModel] = useState([]);
//     const [snackbarOpen, setSnackbarOpen] = useState(false);
//     const [snackbarMessage, setSnackbarMessage] = useState('');
//     const [snackbarSeverity, setSnackbarSeverity] = useState('success');
//     const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
//     const [pendingDeleteIds, setPendingDeleteIds] = useState([]);

//     // PDF states
//     const [pdfUri, setPdfUri] = useState(null);
//     const [pdfLoading, setPdfLoading] = useState(false);
//     const [pdfError, setPdfError] = useState(null);
//     const [pdfOverlayVisible, setPdfOverlayVisible] = useState(false);
//     const [isGeneratingPdf, setIsGeneratingPdf] = useState(false);

//     // Search filter
//     const [filterText, setFilterText] = useState('');

//     const newWinRef = useRef(null);
//     const revokeIntervalRef = useRef(null);

//     const params = { userId, userCategory: role, companyId };

//     // Cleanup on unmount
//     useEffect(() => {
//         return () => {
//             if (revokeIntervalRef.current) clearInterval(revokeIntervalRef.current);
//             if (pdfUri) URL.revokeObjectURL(pdfUri);
//             if (newWinRef.current && !newWinRef.current.closed) newWinRef.current.close();
//         };
//     }, [pdfUri]);

//     // Fetch orders
//     useEffect(() => {
//         (async () => {
//             setLoading(true);
//             try {
//                 const res = await axios.get(`${API_URL}/orders`, {
//                     params: { ...params, mode: "ref" },
//                     headers: { 'Cache-Control': 'no-store' }
//                 });
//                 const raw = Array.isArray(res.data) ? res.data : [];
//                 console.log(res.data);
//                 const rows = raw.map(r => {
//                     const soId = r.SOId ?? r.SOAutoID ?? r.id;
//                     return {
//                         ...r,
//                         id: String(soId),
//                         SOId: Number(soId),
//                         SOAutoID: Number(soId),
//                         BillAmt: Number(r.BillAmt) || 0,
//                     };
//                 });
//                 setOrders(formatRows(rows));
//                 setPendingOrders(formatRows(rows));
//             } catch (err) {
//                 console.error('❌ Failed to fetch orders', err);
//                 setOrders([]);
//                 setPendingOrders([]);
//             } finally {
//                 setLoading(false);
//                 setLoadingPending(false);
//             }
//         })();
//     }, []);

//     // Fetch challans
//     useEffect(() => {
//         (async function fetchChallans() {
//             try {
//                 const res = await axios.get(`${API_URL}/dispatch-challans`, { params });
//                 const data = Array.isArray(res.data) ? res.data : [];
//                 const rows = data.map((row, idx) => ({
//                     id: row.ChallanId ?? idx,
//                     ChallanAutoID: row.ChallanId,
//                     ChallanNumber: row.ChallanNumber,
//                     RefNo: row.RefNo,
//                     ChallanDate: row.ChallanDate ? new Date(row.ChallanDate).toLocaleDateString('en-GB') : '',
//                     clientname: row.FirmName,
//                     contactPerson: row.ContactPerson,
//                     mobileNo: row.MobileNo,
//                     city: row.City,
//                     state: row.state,
//                     BillAmt: Number(row.BillAmt) || 0,
//                     clientId: row.PartyID,
//                 }));
//                 setChallanRows(formatRows(rows));
//             } catch (err) {
//                 console.error('Error fetching challans:', err);
//             } finally {
//                 setChallanLoading(false);
//             }
//         })();
//     }, []);

//     const handleTogglePending = () => setShowPending(prev => !prev);

//     const handleDispatch = () => {
//         if (selectedRows.length === 0) return;
//         const firstOrder = selectedRows[0];
//         const selectedSOIDs = selectedRows.map(r => r.SOAutoID);
//         navigate(`/main/v3/challanMaster-stepper-ref/${firstOrder.clientId}`, { state: { selectedSOIDs } });
//     };

//     const handleView = async (challanAutoID) => {
//         if (isGeneratingPdf) return;
//         setPdfOverlayVisible(true);
//         setIsGeneratingPdf(true);
//         setPdfError(null);
//         setPdfUri(null);

//         if (!challanAutoID) {
//             setPdfOverlayVisible(false);
//             setIsGeneratingPdf(false);
//             return;
//         }

//         const userIdSafe = userId || 'usr1';
//         let formatId = 'format_1';
//         let bookNameToSend = 'Challan';
//         let bookIdToSend = null;

//         try {
//             const found = challanRows.find(c => Number(c.ChallanAutoID) === Number(challanAutoID));
//             if (found?.BookName) bookNameToSend = String(found.BookName).trim();
//             else if (found?.bookName) bookNameToSend = String(found.bookName).trim();
//         } catch (e) { }

//         try {
//             const resp = await axios.get(`${API_URL}/companies`, { params: { companyId } });
//             const comps = Array.isArray(resp?.data?.companies) ? resp.data.companies :
//                 Array.isArray(resp?.data) ? resp.data : [resp.data].filter(Boolean);

//             const eq = (a, b) => String(a ?? '').trim().toLowerCase() === String(b ?? '').trim().toLowerCase();
//             let matched = null;

//             for (const c of comps) {
//                 if (Array.isArray(c.formats)) {
//                     for (const f of c.formats) {
//                         if (eq(f.BookName || f.bookName, bookNameToSend) ||
//                             eq(f.FormName || f.formName, "Challan") ||
//                             String(f.FormName || '').toLowerCase().includes('challan')) {
//                             matched = f;
//                             break;
//                         }
//                     }
//                     if (matched) break;
//                 }
//                 if (eq(c.BookName || c.bookName, bookNameToSend)) { matched = c; break; }
//             }

//             if (matched) {
//                 const id = matched.BookID ?? matched.BookId ?? matched.bookId;
//                 if (id) { formatId = `format_${id}`; bookIdToSend = id; }
//                 else if (matched.FormName || matched.formName) formatId = String(matched.FormName || matched.formName);
//                 bookNameToSend = matched.BookName || matched.bookName || bookNameToSend;
//             }
//         } catch (err) {
//             console.warn("Format detection failed, using defaults");
//         }

//         try {
//             setPdfLoading(true);

//             const { data } = await axios.get(`${API_URL}/get-dispatch-data/${challanAutoID}`, {
//                 params: { companyId },
//                 headers: { 'Cache-Control': 'no-store' }
//             });

//             const { master, items = [] } = data || {};
//             if (!master) throw new Error("No master data returned");

//             let imageBase64 = null;
//             try {
//                 const iconRes = await axios.get(`${API_URL}/company/GetIcon/${companyId}`);
//                 if (iconRes?.data?.success && iconRes?.data?.imageBase64) {
//                     imageBase64 = iconRes.data.imageBase64.replace(/^data:image\/\w+;base64,/, '');
//                 }
//             } catch (e) { /* ignore */ }

//             console.log(data);

//             const transformedItems = items.map(d => ({
//                 ItemCode: d.itemCode || "",
//                 productImage: d.productImage || "",
//                 Remark: d.Remark || "",
//                 hsnCode: d.HSN || "",
//                 description: d.description || "",
//                 qty: Number(d.Qty) || 0,
//                 unit: d.Unit || "",
//                 rate: Number(d.Rate) || 0,
//                 discount: Number(d.Disc) || 0,
//                 cgst: Number(d.CGST) || 0,
//                 sgst: Number(d.SGST) || 0,
//                 igst: Number(d.IGST) || 0,
//                 amount: Number(d.ItemTotal) || 0,
//             }));

//             const pdfData = {
//                 companyId,
//                 companyName: master.clientDetails?.clientname || master.FirmName || "",
//                 address: master.clientDetails?.address || "",
//                 phone: master.clientDetails?.mobileNo || "",
//                 gstNo: master.clientDetails?.gstno || "",
//                 invoiceNo: master.ChallanNumber || "",
//                 referrenceNo: master.PartyPONO || "",
//                 date: master.ChallanDate ? normalizeDate(master.ChallanDate) : "",
//                 transport: "SELF",
//                 challanNo: master.ChallanNumber || "",
//                 poNo: master.PartyPONO || "",
//                 state: master.clientDetails?.state || "",
//                 stateCode: master.clientDetails?.stateCode || "",
//                 LrNo: master.ChallanNumber || "",
//                 vehNo: master.vehicleNumber || "",
//                 LrDate: master.DeliveryDate ? normalizeDate(master.DeliveryDate) : "",
//                 shipToGstNumber: master.clientDetails?.gstno || "",
//                 shipToState: master.clientDetails?.state || "",
//                 items: transformedItems,
//                 toEmail: master.clientDetails?.emailId || "",
//                 totalAmount: Number(master.BillAmt) || 0,
//                 mobileNo: master.clientDetails?.mobileNo || "",
//                 BasicAmt: Number(master.BasicAmt) || 0,
//                 CGSTAmt: Number(master.CGSTAmt) || 0,
//                 SGSTAmt: Number(master.SGSTAmt) || 0,
//                 IGSTAmt: Number(master.IGSTAmt) || 0,
//                 RoundOff: Number(master.RoundOff) || 0,
//                 BillAmt: Number(master.BillAmt) || 0,
//                 clientState: master.clientState || "",
//                 imageBase64: imageBase64 || null,
//             };

//             const pdfResp = await axios.post(
//                 `${PDF_API_BASE}/api/pdf/Challan/${challanAutoID}`,
//                 {
//                     docId: challanAutoID,
//                     userId: userIdSafe,
//                     formatId,
//                     data: pdfData,
//                     company: {
//                         CompId: companyId,
//                         CompanyName: selectedCompany?.CompanyName || selectedCompany?.companyName || "",
//                         Address: selectedCompany?.Address || selectedCompany?.address || "",
//                         MobileNo: selectedCompany?.MobileNo || selectedCompany?.mobileNo || "",
//                         GSTNo: selectedCompany?.GSTNo || selectedCompany?.gstNo || "",
//                         imageBase64: imageBase64 || null,
//                         city: selectedCompany.City || null,
//                     }
//                 },
//                 { responseType: "blob", timeout: 120000 }
//             );

//             const blob = pdfResp.data;
//             if (!blob || blob.size === 0) throw new Error("Empty PDF");

//             const blobUrl = URL.createObjectURL(new Blob([blob], { type: "application/pdf" }));

//             const newWin = window.open("", "_blank");
//             if (newWin) {
//                 newWinRef.current = newWin;
//                 newWin.location.href = blobUrl;
//                 newWin.focus();

//                 const checker = setInterval(() => {
//                     if (newWin.closed) {
//                         URL.revokeObjectURL(blobUrl);
//                         clearInterval(checker);
//                         newWinRef.current = null;
//                     }
//                 }, 1000);
//                 revokeIntervalRef.current = checker;
//             } else {
//                 if (pdfUri) URL.revokeObjectURL(pdfUri);
//                 setPdfUri(blobUrl);
//                 setSnackbarMessage("Popup blocked — showing PDF inline");
//                 setSnackbarSeverity("warning");
//                 setSnackbarOpen(true);
//             }

//         } catch (err) {
//             console.error("Challan PDF Error:", err);
//             setPdfError("Failed to generate Challan PDF");
//             setSnackbarMessage("Could not load PDF. Please try again.");
//             setSnackbarSeverity("error");
//             setSnackbarOpen(true);
//         } finally {
//             setPdfOverlayVisible(false);
//             setIsGeneratingPdf(false);
//             setPdfLoading(false);
//         }
//     };

//     const handleChallanDelete = (objAryId) => {
//         if (!objAryId?.length) {
//             setSnackbarMessage('No challans selected.');
//             setSnackbarSeverity('warning');
//             setSnackbarOpen(true);
//             return;
//         }

//         setPendingDeleteIds(objAryId);
//         setOpenDeleteDialog(true);
//     };

//     const confirmChallanDelete = async () => {
//         // if (!objAryId.length || !window.confirm(`Are you sure you want to delete ${objAryId.length} challan(s)?`)) return;
//         const numericIds = pendingDeleteIds.map(Number);
//         setOpenDeleteDialog(false);
//         try {
//             const payload = { objAryId: numericIds, companyId };
//             const { data } = await axios.post(`${API_URL}/delete-challans`, payload);
//             console.log(data);
//             // if (totalDeleted > 0) {
//             //     setChallanRows(prev =>
//             //         prev.filter(row =>
//             //             !deletedIds.includes(Number(row.ChallanAutoID))
//             //         )
//             //     );
//             //     setChallanSelectionModel(prev => prev.filter(id => !numericIds.includes(id)));
//             //     setSnackbarMessage(`Deleted successfully.`);
//             //     setSnackbarSeverity('success');
//             // } else if (data.referencedIds && data.referencedIds.length > 0) {
//             //     setSnackbarMessage(data.message || 'Some challans have references.');
//             //     setSnackbarSeverity('warning');
//             // } else {
//             //     setSnackbarMessage('No challans were deleted.');
//             //     setSnackbarSeverity('info');
//             // }

//             const deletedIds = (data.deletedIds || []).map(Number);
//             const referencedIds = (data.referencedIds || []).map(Number);

//             // ✅ 1. REMOVE deleted challans from UI immediately
//             if (deletedIds.length > 0) {
//                 setChallanRows(prev =>
//                     prev.filter(
//                         row => !deletedIds.includes(Number(row.ChallanAutoID))
//                     )
//                 );

//                 setChallanSelectionModel(prev =>
//                     prev.filter(id => !deletedIds.includes(Number(id)))
//                 );
//             }

//             // ✅ 2. CORRECT challan count (NOT DB rows)
//             const deletedCount = deletedIds.length;

//             // ✅ Show deleted count
//             if (deletedCount > 0) {
//                setSnackbarMessage("Deleted Successfully.");
//                 setSnackbarSeverity("success");
//                 setSnackbarOpen(true);
//             }

//             // ⚠️ Show referenced IDs clearly
//             if (referencedIds.length > 0 && deletedCount <= 0) {
//               setSnackbarMessage("Cannot delete the selected item(s) because they are referenced in other records.");
//                 setSnackbarSeverity("warning");
//                 setSnackbarOpen(true);
//             }
//         } catch (err) {
//             console.error('Error deleting challans:', err);
//             setSnackbarMessage(`Failed: ${err.response?.data?.message || err.message}`);
//             setSnackbarSeverity('error');
//             setSnackbarOpen(true);
//         } finally {
//             setPendingDeleteIds([]);
//         }
//     };

//     // Filtered data
//     const filteredPendingOrders = useMemo(() => {
//         if (!filterText) return pendingOrders;
//         const lower = filterText.toLowerCase();
//         return pendingOrders.filter(row =>
//             String(row.SONumber || "").toLowerCase().includes(lower) ||
//             String(row.PartyName || "").toLowerCase().includes(lower)
//         );
//     }, [pendingOrders, filterText]);

//     const filteredChallans = useMemo(() => {
//         if (!filterText) return challanRows;
//         const lower = filterText.toLowerCase();
//         return challanRows.filter(row =>
//             String(row.ChallanNumber || "").toLowerCase().includes(lower) ||
//             String(row.clientname || "").toLowerCase().includes(lower)
//         );
//     }, [challanRows, filterText]);

//     // === Mobile Card Renderers (Redesigned) ===

//     const renderPendingOrderCards = () => {
//         if (loadingPending) return <Typography sx={{ p: 4, textAlign: 'center' }}>Loading orders...</Typography>;
//         if (filteredPendingOrders.length === 0) return <Typography sx={{ p: 4, textAlign: 'center' }}><CustomNoDataOverlay /></Typography>;

//         return filteredPendingOrders.map((row) => {
//             const isSelected = selectedRowIds.includes(Number(row.SOId));
//             const avatarColor = stringToColor(row.PartyName || 'Order');
//             const initials = getInitials(row.PartyName);
//             const locationText = [row.City, row.state].filter(Boolean).join(', ') || '—';

//             const toggleSelection = (e) => {
//                 e.stopPropagation();
//                 setSelectedRows(prevRows => {
//                     const prevClientId = prevRows.length > 0 ? String(prevRows[0].clientId ?? '') : null;
//                     const rowClientId = String(row.clientId ?? '');
//                     if (prevClientId && rowClientId !== prevClientId) {
//                         setSnackbarMessage('Client mismatch — select only from same client.');
//                         setSnackbarSeverity('warning');
//                         setSnackbarOpen(true);
//                         return prevRows;
//                     }
//                     const exists = prevRows.some(r => Number(r.SOId) === Number(row.SOId));
//                     const newRows = exists ? prevRows.filter(r => Number(r.SOId) !== Number(row.SOId)) : [...prevRows, row];
//                     setSelectedRowIds(newRows.map(r => Number(r.SOId)));
//                     return newRows;
//                 });
//             };

//             return (
//                 <Card key={row.SOId} sx={{ mb: 2, borderLeft: '6px solid #1976d2', borderRadius: 2, overflow: 'hidden', boxShadow: 3, bgcolor: 'background.paper' }} >
//                     <CardContent sx={{ p: 2 }}>
//                         <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
//                             <Box sx={{ display: 'flex', alignItems: 'center', flex: 1 }}>
//                                 <Checkbox checked={isSelected} onChange={toggleSelection} size="small" />
//                                 <Avatar sx={{ bgcolor: avatarColor, width: 36, height: 36, ml: 1 }}>
//                                     <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>{initials}</Typography>
//                                 </Avatar>
//                                 <Box sx={{ ml: 1.5, flex: 1 }}>
//                                     <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
//                                         {row.PartyName || 'N/A'}
//                                     </Typography>
//                                     <Typography variant="caption" color="text.secondary">
//                                         {locationText}
//                                     </Typography>
//                                 </Box>
//                             </Box>
//                             <Typography variant="caption" color="text.secondary" sx={{ minWidth: 80, textAlign: 'right' }}>
//                                 {normalizeDate(row.SODate)}
//                             </Typography>
//                         </Box>

//                         <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 1 }}>
//                             <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                                 <DescriptionIcon sx={{ fontSize: 18, color: 'text.secondary', mr: 1 }} />
//                                 <Typography variant="body2" color="text.secondary">
//                                     {row.SONumber || 'N/A'}
//                                 </Typography>
//                             </Box>
//                             <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
//                                 ₹{row.BillAmt.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
//                             </Typography>
//                         </Box>

//                         {(row.ContactPerson || row.MobileNo) && (
//                             <>
//                                 <Divider sx={{ my: 1.5 }} />
//                                 <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//                                     <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                                         <PersonIcon sx={{ fontSize: 18, color: 'text.secondary', mr: 1 }} />
//                                         <Typography variant="body2" color="text.secondary">
//                                             {row.ContactPerson || 'N/A'}
//                                         </Typography>
//                                     </Box>
//                                     {row.MobileNo && (
//                                         <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                                             <PhoneIcon sx={{ fontSize: 18, color: 'text.secondary', mr: 1 }} />
//                                             <Typography variant="body2" color="text.secondary">
//                                                 {row.MobileNo}
//                                             </Typography>
//                                         </Box>
//                                     )}
//                                 </Box>
//                             </>
//                         )}
//                     </CardContent>
//                 </Card>
//             );
//         });
//     };

//     const renderChallanCards = () => {
//         if (challanLoading) return <Typography sx={{ p: 4, textAlign: 'center' }}>Loading challans...</Typography>;
//         if (filteredChallans.length === 0) return <Typography sx={{ p: 4, textAlign: 'center' }}><CustomNoDataOverlay /></Typography>;

//         return filteredChallans.map((row) => {
//             const isSelected = challanSelectionModel.includes(Number(row.ChallanAutoID));
//             const avatarColor = stringToColor(row.clientname || 'Challan');
//             const initials = getInitials(row.clientname);
//             const locationText = [row.city, row.state].filter(Boolean).join(', ') || '—';

//             return (
//                 <Card
//                     key={row.ChallanAutoID}
//                     onClick={() => navigate(`/main/v3/challanMaster-edit/${row.ChallanAutoID}`, { state: { clientId: row.clientId } })}
//                     sx={{
//                         mb: 2,
//                         borderLeft: '6px solid #1976d2',
//                         borderRadius: 2,
//                         overflow: 'hidden',
//                         boxShadow: 3,
//                         bgcolor: 'background.paper',
//                         cursor: 'pointer',
//                         '&:hover': { boxShadow: 6 }
//                     }}
//                 >
//                     <CardContent sx={{ p: 2 }}>
//                         <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
//                             <Box sx={{ display: 'flex', alignItems: 'center', flex: 1 }}>
//                                 {role !== 'User' && (
//                                     <Checkbox
//                                         checked={isSelected}
//                                         onChange={() => {
//                                             setChallanSelectionModel(prev =>
//                                                 prev.includes(Number(row.ChallanAutoID))
//                                                     ? prev.filter(id => id !== Number(row.ChallanAutoID))
//                                                     : [...prev, Number(row.ChallanAutoID)]
//                                             );
//                                         }}
//                                         size="small"
//                                     />
//                                 )}
//                                 <Avatar sx={{ bgcolor: avatarColor, width: 36, height: 36, ml: 1 }}>
//                                     <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>{initials}</Typography>
//                                 </Avatar>
//                                 <Box sx={{ ml: 1.5, flex: 1 }}>
//                                     <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
//                                         {row.clientname || 'N/A'}
//                                     </Typography>
//                                     <Typography variant="caption" color="text.secondary">
//                                         {locationText}
//                                     </Typography>
//                                 </Box>
//                             </Box>
//                             <Typography variant="caption" color="text.secondary" sx={{ minWidth: 80, textAlign: 'right' }}>
//                                 {row.ChallanDate || '—'}
//                             </Typography>
//                         </Box>

//                         <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 1 }}>
//                             <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                                 <DescriptionIcon sx={{ fontSize: 18, color: 'text.secondary', mr: 1 }} />
//                                 <Typography
//                                     variant="body2"
//                                     sx={{ color: 'primary.main', textDecoration: 'underline' }}
//                                 >
//                                     {row.ChallanNumber || 'N/A'}
//                                 </Typography>
//                             </Box>
//                             <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
//                                 ₹{row.BillAmt.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
//                             </Typography>
//                         </Box>

//                         {row.RefNo && (
//                             <Box sx={{ display: 'flex', alignItems: 'center', mt: 0.5 }}>
//                                 <LinkIcon sx={{ fontSize: 18, color: 'text.secondary', mr: 1 }} />
//                                 <Typography variant="body2" color="text.secondary">
//                                     {row.RefNo}
//                                 </Typography>
//                             </Box>
//                         )}

//                         {(row.contactPerson || row.mobileNo) && (
//                             <>
//                                 <Divider />
//                                 <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//                                     <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                                         <PersonIcon sx={{ fontSize: 18, color: 'text.secondary', mr: 1 }} />
//                                         <Typography variant="body2" color="text.secondary">
//                                             {row.contactPerson || 'N/A'}
//                                         </Typography>
//                                     </Box>
//                                     <IconButton color="primary" onClick={(e) => { e.stopPropagation(); handleView(row.ChallanAutoID); }}>
//                                         <PrintIcon />
//                                     </IconButton>
//                                 </Box>
//                             </>
//                         )}
//                     </CardContent>
//                 </Card>
//             );
//         });
//     };

//     // === Original Columns (for desktop) ===
//     const columns = useMemo(() => [
//         {
//             field: 'select', headerName: '', width: 40, sortable: false, disableColumnMenu: true, filterable: false,
//             renderHeader: () => {
//                 const referenceClientId = selectedRows.length > 0 ? String(selectedRows[0].clientId ?? '') : (pendingOrders[0] ? String(pendingOrders[0].clientId ?? '') : null);
//                 const eligibleRows = referenceClientId ? pendingOrders.filter(row => String(row.clientId ?? '') === referenceClientId) : [];
//                 const allSelected = eligibleRows.length > 0 && eligibleRows.every(row => selectedRowIds.includes(Number(row.SOId)));
//                 const someSelected = selectedRowIds.length > 0 && !allSelected;

//                 return (
//                     <Checkbox checked={allSelected} indeterminate={someSelected} disabled={!referenceClientId}
//                         onChange={(e) => {
//                             if (e.target.checked) {
//                                 const newSelectedRows = eligibleRows.slice();
//                                 setSelectedRows(newSelectedRows);
//                                 setSelectedRowIds(newSelectedRows.map(r => Number(r.SOId)));
//                             } else {
//                                 setSelectedRows([]);
//                                 setSelectedRowIds([]);
//                             }
//                         }}
//                     />
//                 );
//             },
//             renderCell: ({ row }) => {
//                 const rowIdNum = Number(row.SOId);
//                 const checked = selectedRowIds.includes(rowIdNum);

//                 return (
//                     <Checkbox checked={checked}
//                         onChange={(e) => {
//                             const checkedNow = e.target.checked;
//                             setSelectedRows(prevRows => {
//                                 const prevClientId = prevRows.length > 0 ? String(prevRows[0].clientId ?? '') : null;
//                                 if (checkedNow) {
//                                     const rowClientId = String(row.clientId ?? '');
//                                     const effectiveClientId = prevClientId ?? rowClientId;
//                                     if (prevClientId && rowClientId !== prevClientId) {
//                                         setSnackbarMessage('Oops! Client name mismatch — select only orders from the same client.');
//                                         setSnackbarSeverity('warning');
//                                         setSnackbarOpen(true);
//                                         return prevRows;
//                                     }
//                                     const already = prevRows.some(r => String(r.SOId) === String(row.SOId));
//                                     if (already) return prevRows;
//                                     const newRows = [...prevRows, row];
//                                     setSelectedRowIds(newRows.map(r => Number(r.SOId)));
//                                     return newRows;
//                                 } else {
//                                     const newRows = prevRows.filter(r => Number(r.SOId) !== rowIdNum);
//                                     setSelectedRowIds(newRows.map(r => Number(r.SOId)));
//                                     return newRows;
//                                 }
//                             });
//                         }}
//                     />
//                 );
//             },
//         },
//         { field: 'SODate', headerName: 'Order Date', flex: 0.8, filterable: false, valueFormatter: (p) => normalizeDate(p) },
//         { field: "SONumber", headerName: "Order No.", flex: 1.2 },
//         { field: 'PartyPONO', headerName: 'Ref No.', flex: 1, },
//         {
//             field: 'PartyName', headerName: 'Client Details', flex: 2.5,
//             renderCell: (params) => (
//                 <Box sx={{ whiteSpace: 'normal', wordBreak: 'break-word', my: 1 }}>
//                     <Typography variant='subtitle2' sx={{ fontSize: '0.85rem' }}>{params.row.PartyName || '-'}</Typography>
//                     <Stack direction='row' alignItems='center' spacing={1}>
//                         <FaUser color='#FF9800' />
//                         <Typography variant='body2'>{params.row.ContactPerson || '-'}</Typography>
//                     </Stack>
//                     <Typography variant='body2' color='text.secondary'>📲 {params.row.MobileNo || '-'}</Typography>
//                 </Box>
//             ),
//         },
//         ...(role !== "SalesMan" ? [{ field: "BillAmt", headerName: "Total Amt", flex: 1, align: "right", headerAlign: "right", valueFormatter: (p) => `₹${Number(p || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` }] : []),
//         {
//             field: 'location', headerName: 'Location', flex: 1.5, filterable: false,
//             renderCell: (params) => (
//                 <Box sx={{ display: 'flex', flexDirection: 'column' }}>
//                     <Typography variant="body2">{params.row.City || '-'}</Typography>
//                     <Typography variant="caption" color="text.secondary">{params.row.state || '-'}</Typography>
//                 </Box>
//             ),
//         },
//     ], [selectedRows, selectedRowIds, pendingOrders, role]);

//     const challanColumns = useMemo(() => {
//         let cols = [
//             { field: 'ChallanDate', headerName: 'Date', flex: 0.8, filterable: false, },
//             {
//                 field: 'ChallanNumber', headerName: 'Challan Number', flex: 1.2,
//                 renderCell: (params) => (
//                     <Typography
//                         variant="body2"
//                         sx={{ color: 'blue', textDecoration: 'underline', cursor: 'pointer' }}
//                         onClick={() => navigate(`/main/v3/challanMaster-edit/${params.row.ChallanAutoID}`, { state: { clientId: params.row.clientId } })}
//                     >
//                         {params.value ?? '-'}
//                     </Typography>
//                 ),
//             },
//             { field: 'RefNo', headerName: 'Ref No.', flex: 1 },
//             {
//                 field: 'clientname', headerName: 'Client', flex: 2.5,
//                 renderCell: (params) => (
//                     <Box sx={{ whiteSpace: 'normal', wordBreak: 'break-word', my: 1 }}>
//                         <Typography variant='subtitle2' sx={{ fontSize: '0.85rem' }}>{params.row.clientname || '-'}</Typography>
//                         <Stack direction='row' alignItems='center' spacing={1}>
//                             <FaUser color='#FF9800' />
//                             <Typography variant='body2'>{params.row.contactPerson || '-'}</Typography>
//                         </Stack>
//                         <Typography variant='body2' color='text.secondary'>📲 {params.row.mobileNo || '-'}</Typography>
//                     </Box>
//                 ),
//             },
//             {
//                 field: 'location', headerName: 'Location', flex: 1.5, filterable: false,
//                 renderCell: (params) => (
//                     <Box sx={{ display: 'flex', flexDirection: 'column' }}>
//                         <Typography variant="body2">{params.row.city || '-'}</Typography>
//                         <Typography variant="caption" color="text.secondary">{params.row.state || '-'}</Typography>
//                     </Box>
//                 ),
//             },
//             {
//                 field: 'BillAmt', headerName: 'Bill Amount', flex: 1, align: 'right', headerAlign: 'right',
//                 valueFormatter: (p) => `₹${Number(p || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
//             },
//             {
//                 field: 'actions', headerName: 'Action', flex: 0.8, align: 'right', headerAlign: 'right', filterable: false,
//                 renderCell: (params) => (
//                     <IconButton color="primary" onClick={() => handleView(params.row.ChallanAutoID)}>
//                         <PrintIcon />
//                     </IconButton>
//                 ),
//             },
//         ];

//         if (role !== 'User') {
//             cols.unshift({
//                 field: 'select', headerName: '', width: 50, sortable: false, disableColumnMenu: true, filterable: false,
//                 renderHeader: () => {
//                     const allSelected = challanRows.length > 0 && challanRows.every(r => challanSelectionModel.includes(Number(r.ChallanAutoID)));
//                     const someSelected = challanSelectionModel.length > 0 && !allSelected;
//                     return (
//                         <Checkbox
//                             checked={allSelected}
//                             indeterminate={someSelected}
//                             onChange={(e) => setChallanSelectionModel(e.target.checked ? challanRows.map(r => Number(r.ChallanAutoID)) : [])}
//                         />
//                     );
//                 },
//                 renderCell: ({ row }) => (
//                     <Checkbox
//                         checked={challanSelectionModel.includes(Number(row.ChallanAutoID))}
//                         onChange={(e) => {
//                             const checked = e.target.checked;
//                             setChallanSelectionModel(prev =>
//                                 checked
//                                     ? [...prev, Number(row.ChallanAutoID)]
//                                     : prev.filter(id => id !== Number(row.ChallanAutoID))
//                             );
//                         }}
//                     />
//                 ),
//             });

//             cols.push({
//                 field: 'delete', headerName: 'Delete', flex: 0.6, align: 'right', headerAlign: 'right', filterable: false,
//                 renderCell: (params) => {
//                     const rowId = Number(params.row.ChallanAutoID);
//                     const isRowSelected = challanSelectionModel.includes(rowId);

//                     return (
//                         <Tooltip title={isRowSelected ? 'Delete this challan' : 'Select this row to delete'}>
//                             <span>
//                                 <IconButton
//                                     color="error"
//                                     size="small"
//                                     disabled={!isRowSelected}
//                                     onClick={() => handleChallanDelete(challanSelectionModel)}
//                                 >
//                                     <DeleteIcon />
//                                 </IconButton>
//                             </span>
//                         </Tooltip>
//                     );
//                 },
//             });
//         }
//         return cols;
//     }, [challanRows, challanSelectionModel, role, navigate]);

//     return (
//         <Box sx={{ pt: 0.7, px: { xs: 2, sm: 3, md: 4 } }}>
//             {/* Header */}

//             <Box sx={{ position: 'relative', mb: 1.5 }}>
//                 <Box sx={{
//                     position: 'absolute',
//                     left: 0,
//                     top: '50%',
//                     transform: 'translateY(-50%)',
//                 }}>
//                     <Tooltip title="Add New Challan">
//                         <IconButton component={Link} to="/main/v3/challanMaster-stepper" sx={{ color: "orange" }}>
//                             <VscNewFile size={22} />
//                         </IconButton>
//                     </Tooltip>
//                 </Box>

//                 <Typography
//                     variant="h5"
//                     sx={{
//                         textAlign: 'center',
//                         fontSize: { xs: '1.25rem', sm: '1.5rem' },
//                         fontWeight: 600,
//                     }}
//                 >
//                     Sale Challans Details
//                 </Typography>


//                 <Box sx={{
//                     position: 'absolute',
//                     right: 0,
//                     top: '50%',
//                     transform: 'translateY(-50%)',
//                     zIndex: 1, display: "flex", alignItems: "center", gap: 1.5
//                 }}>
//                     {selectedRows.length > 0 && (
//                         <Button variant="contained" color="primary" onClick={handleDispatch} size='small'>
//                             Go To Dispatch
//                         </Button>
//                     )}
//                     <Button
//                         variant="contained"
//                         size="small"
//                         onClick={handleTogglePending}
//                     >
//                         {showPending ? 'Hide' : 'Show'} Orders
//                     </Button>
//                 </Box>

//             </Box>
//             <Paper elevation={3} sx={{ borderRadius: 2, overflow: 'hidden', width: '100%' }}>
//                 <Box sx={{ p: { xs: 0.5, md: 0.5 } }}>
//                     {/* Search (mobile only) */}
//                     {!isDesktop && (
//                         <Box sx={{ mb: 3 }}>
//                             <TextField
//                                 fullWidth
//                                 size="small"
//                                 placeholder="Search by number or client..."
//                                 value={filterText}
//                                 onChange={(e) => setFilterText(e.target.value)}
//                                 InputProps={{
//                                     startAdornment: <InputAdornment position="start"><SearchIcon /></InputAdornment>,
//                                 }}
//                             />
//                         </Box>
//                     )}

//                     {/* Pending Orders Section */}
//                     {showPending && (
//                         <Paper elevation={2} sx={{ borderRadius: 3, p: 1.5, overflow: 'hidden', mb: 2.5 }}>
//                             <Grid container justifyContent="space-between" alignItems="center" mb={1.5}>
//                                 <Typography variant="h6" fontWeight={600}> My Orders</Typography>
//                                 {/* {selectedRows.length > 0 && (
//                                 <Button variant="contained" color="primary" onClick={handleDispatch} size='small'>
//                                     Go To Dispatch
//                                 </Button>
//                             )} */}
//                             </Grid>

//                             <Box sx={{ height: '71vh', width: '100%' }}>
//                                 {isDesktop ? (<>
//                                     {showLoadingSpinner ? <LoadingSpinner message="Loading orders..." /> : pendingOrders?.length === 0 ? <NoDataComponent /> :
//                                         <DataGrid
//                                             rows={pendingOrders}
//                                             columns={columns}
//                                             getRowId={(row) => String(row.SOId)}
//                                             initialState={{ pagination: { paginationModel: { pageSize: 50, page: 0 } } }}
//                                             pageSizeOptions={[5, 25, 50, 100]}
//                                             getRowHeight={() => 'auto'}
//                                             sx={{
//                                                 '& .MuiDataGrid-columnHeaders': { backgroundColor: themeColors.neutral.gridHeader, borderBottom: `1px solid ${themeColors.neutral.border}` },
//                                                 '& .MuiDataGrid-columnHeaderTitle': { fontWeight: 700 },
//                                                 '& .MuiDataGrid-columnHeader': { backgroundColor: themeColors.neutral.gridHeader, color: themeColors.neutral.ink, fontWeight: 700, fontSize: '0.74rem', textTransform: 'uppercase', letterSpacing: '0.06em' },

//                                                 // Background styling
//                                                 '& .MuiDataGrid-filler': { backgroundColor: '#FFFFFF' },
//                                                 '& .MuiDataGrid-scrollbarFiller': { backgroundColor: themeColors.neutral.gridHeader },

//                                                 // Row styling
//                                                 '& .MuiDataGrid-row:nth-of-type(odd)': { backgroundColor: themeColors.neutral.surface },
//                                                 '& .MuiDataGrid-row:nth-of-type(even)': { backgroundColor: themeColors.neutral.surfaceAlt },
//                                                 '& .MuiDataGrid-row:hover': { backgroundColor: themeColors.primary.tint },

//                                                 // Selected row styling (with !important to override default MUI)
//                                                 '& .MuiDataGrid-row.Mui-selected': { backgroundColor: `${themeColors.primary.selected} !important` },

//                                                 // Cell content alignment
//                                                 '& .MuiDataGrid-cell': {
//                                                     display: 'flex',
//                                                     alignItems: 'center'
//                                                 },
//                                             }}
//                                             slots={{
//                                                 noResultsOverlay: CustomNoDataOverlay
//                                             }}
//                                         />}</>
//                                 ) : (
//                                     <Box sx={{ px: 1 }}>
//                                         {pendingOrders?.length === 0 ? <NoDataComponent /> : renderPendingOrderCards()}
//                                     </Box>
//                                 )}
//                             </Box>
//                         </Paper>
//                     )}

//                     {/* Challan List */}
//                     <Paper elevation={3} sx={{ borderRadius: 3, p: 1.5, overflow: 'hidden' }}>
//                         {/* <Box sx={{ p: { xs: 2, md: 3 } }}> */}
//                         <Box display='flex' justifyContent='space-between' alignItems='center' mb={1.5}>
//                             <Typography variant='h6' fontWeight={600}>Challan List</Typography>
//                         </Box>
//                         {isDesktop ? (
//                             <Box sx={{ height: '71vh', width: '100%' }}>
//                                 {showLoadingSpinner ? <LoadingSpinner message="Loading orders..." /> :
//                                     challanRows?.length === 0 ? <NoDataComponent /> :
//                                         <DataGrid
//                                             rows={challanRows}
//                                             getRowHeight={() => 'auto'}
//                                             getRowId={(row) => row.ChallanAutoID}
//                                             columns={challanColumns}
//                                             pageSizeOptions={[5, 25, 50, 100]}
//                                             disableRowSelectionOnClick
//                                             sx={{
//                                                 '& .MuiDataGrid-columnHeaders': { backgroundColor: themeColors.neutral.gridHeader, borderBottom: `1px solid ${themeColors.neutral.border}` },
//                                                 '& .MuiDataGrid-columnHeaderTitle': { fontWeight: 700 },
//                                                 '& .MuiDataGrid-columnHeader': { backgroundColor: themeColors.neutral.gridHeader, color: themeColors.neutral.ink, fontWeight: 700, fontSize: '0.74rem', textTransform: 'uppercase', letterSpacing: '0.06em' },

//                                                 // Background styling
//                                                 '& .MuiDataGrid-filler': { backgroundColor: '#FFFFFF' },
//                                                 '& .MuiDataGrid-scrollbarFiller': {
//                                                     backgroundColor: '#E0E0E0',
//                                                 },

//                                                 // Row styling
//                                                 '& .MuiDataGrid-row:nth-of-type(odd)': {
//                                                     backgroundColor: '#FFFFFF',
//                                                 },
//                                                 '& .MuiDataGrid-row:nth-of-type(even)': {
//                                                     backgroundColor: '#F9FAFB',
//                                                 },
//                                                 '& .MuiDataGrid-row:hover': {
//                                                     backgroundColor: '#f1f5f9',
//                                                 },

//                                                 // Selected row styling
//                                                 '& .MuiDataGrid-row.Mui-selected': {
//                                                     backgroundColor: '#BDBDBD !important',
//                                                 },

//                                                 // Cell alignment
//                                                 '& .MuiDataGrid-cell': {
//                                                     display: 'flex',
//                                                     alignItems: 'center',
//                                                 },
//                                             }}
//                                             slots={{
//                                                 noResultsOverlay: CustomNoDataOverlay
//                                             }}
//                                         />}
//                             </Box>
//                         ) : (
//                             <Box sx={{ px: 1 }}>
//                                 {challanRows?.length === 0 ? <NoDataComponent /> : renderChallanCards()}
//                             </Box>
//                         )}
//                         {/* </Box> */}
//                     </Paper>
//                 </Box>
//             </Paper>

//             {/* PDF Viewer / Status */}
//             {pdfError && <Alert severity="error" sx={{ mt: 2 }}>PDF Error: {pdfError}</Alert>}
//             {pdfLoading && <Box sx={{ mt: 2, display: "flex", alignItems: "center", gap: 1 }}><CircularProgress size={18} /> <Typography>Preparing PDF...</Typography></Box>}
//             {pdfUri && <Box sx={{ mt: 2 }}><PdfViewer uri={pdfUri} /></Box>}

//             {/* Overlay */}
//             {pdfOverlayVisible && (
//                 <Box sx={{ position: "fixed", inset: 0, bgcolor: "rgba(0,0,0,0.92)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 9999, backdropFilter: "blur(4px)" }}>
//                     <Box sx={{ textAlign: "center", bgcolor: "#111", p: "40px 60px", borderRadius: "20px" }}>
//                         <CircularProgress size={60} thickness={4} sx={{ color: "#fff" }} />
//                         <Typography variant="h6" sx={{ color: "#fff", mt: 3, fontWeight: 600 }}>Generating Challan PDF…</Typography>
//                         <Typography variant="body2" sx={{ color: "#aaa", mt: 1 }}>Please wait</Typography>
//                     </Box>
//                 </Box>
//             )}

//             <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={() => setSnackbarOpen(false)} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
//                 <Alert onClose={() => setSnackbarOpen(false)} severity={snackbarSeverity} variant="filled">
//                     {snackbarMessage}
//                 </Alert>
//             </Snackbar>

//             <Dialog
//                 open={openDeleteDialog}
//                 onClose={() => setOpenDeleteDialog(false)}
//                 maxWidth="xs"
//                 fullWidth
//             >
//                 <DialogTitle>Confirm Deletion</DialogTitle>

//                 <DialogContent>
//                     <Typography variant="body2">
//                         Are you sure you want to delete{" "}
//                         <strong>{pendingDeleteIds.length}</strong> challan(s)?
//                     </Typography>
//                 </DialogContent>

//                 <DialogActions>
//                     <Button onClick={() => setOpenDeleteDialog(false)} variant='outlined'>
//                         Cancel
//                     </Button>
//                     <Button color="error" variant="contained" onClick={confirmChallanDelete}>
//                         Delete
//                     </Button>
//                 </DialogActions>
//             </Dialog>

//         </Box>
//     );
// }






import { colors as themeColors, gradients } from '../utils/theme';
import { useEffect, useMemo, useState, useCallback, useRef } from 'react';
import { Box, Typography, Button, CircularProgress, Paper, Grid, IconButton, Stack, Tooltip, Snackbar, Alert, Checkbox, Card, CardContent, Avatar, TextField, InputAdornment, Divider, Dialog, DialogTitle, DialogContent, DialogActions, Chip, Autocomplete, RadioGroup, Radio, FormControlLabel, LinearProgress } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import SearchIcon from '@mui/icons-material/Search';
import { DataGrid } from '@mui/x-data-grid';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import { FaUser } from 'react-icons/fa';
import { VscNewFile } from 'react-icons/vsc';
import { useMediaQuery, useTheme } from '@mui/material';
import PdfViewer from '../components/PdfViewer';
import { useAuth } from '../context/AuthContext';
import useDataLoadingState from '../hooks/useDataLoadingState';
import LoadingSpinner from '../components/Common/LoadingSpinner';
import SkeletonLoader from '../components/SkeletonLoader';
import LoadingOverlay from '../components/LoadingOverlay';
import { motion } from 'framer-motion';
import DescriptionIcon from '@mui/icons-material/Description';
import PersonIcon from '@mui/icons-material/Person';
import PhoneIcon from '@mui/icons-material/Phone';
import LinkIcon from '@mui/icons-material/Link';
import PrintIcon from '@mui/icons-material/Print';
import { formatRows } from '../utils/formatRows';
import NoDataComponent from '../components/NoDataComponent';
import CustomNoDataOverlay from '../components/CustomNoDataOverlay';
import CenterLoader from '../components/CenterLoader';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import FilterListIcon from '@mui/icons-material/FilterList';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreVertIcon from '@mui/icons-material/MoreVert';
// import { Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import EwayBillMaster from './EwayBill';
import * as XLSX from 'xlsx';

const getFinancialYearRange = (now = new Date()) => {
    const month = now.getMonth();
    const startYear = month >= 3 ? now.getFullYear() : now.getFullYear() - 1;
    const from = `${startYear}-04-01`;
    const to = `${startYear + 1}-03-31`;
    return { from, to };
};

const normalizeDate = (v) => typeof v === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(v) ? v.split('-').reverse().join('/') : v || '-';

// Helper for avatar color and initials
function stringToColor(string) {
    let hash = 0;
    for (let i = 0; i < string.length; i++) {
        hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }
    const colors = ['#e74c3c', '#3498db', '#2ecc71', '#e67e22', '#9b59b6', '#1abc9c', '#3f51b5', '#e91e63', '#795548', '#00bcd4'];
    return colors[Math.abs(hash) % colors.length];
}

function getInitials(name) {
    if (!name) return 'C';
    return name.trim().charAt(0).toUpperCase();
}

export default function OrdersAdmin({ connectionString, pdfString }) {
    const { user, selectedCompany } = useAuth();
    const API_URL = `${connectionString}/api`;
    const PDF_API_BASE = pdfString;
    const userId = user?.UserId || null;
    const companyId = selectedCompany?.CompId || null;
    const AppRegID = selectedCompany?.AppRegID || null;
    const role = user?.UserCategory;
    const navigate = useNavigate();

    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('md')); // ≥ md → DataGrid, < md → Cards
    const isSmallDevice = useMediaQuery(theme.breakpoints.down(500));

    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showPending, setShowPending] = useState(false);
    const [pendingOrders, setPendingOrders] = useState([]);
    const [loadingPending, setLoadingPending] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [selectedRowIds, setSelectedRowIds] = useState([]);
    const [challanRows, setChallanRows] = useState([]);
    const [challanLoading, setChallanLoading] = useState(true);
    const [challanSelectionModel, setChallanSelectionModel] = useState([]);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarSeverity, setSnackbarSeverity] = useState('success');
    const [filterPopupOpen, setFilterPopupOpen] = useState(false);
    const [filterPopupMode, setFilterPopupMode] = useState('datewise');
    const [filterPopupFromDate, setFilterPopupFromDate] = useState('');
    const [filterPopupToDate, setFilterPopupToDate] = useState('');
    const [filterPopupFirms, setFilterPopupFirms] = useState([]);
    const [firmOptions, setFirmOptions] = useState([]);
    const [firmAllOptions, setFirmAllOptions] = useState([]);
    const [firmInputValue, setFirmInputValue] = useState('');
    const [firmLoading, setFirmLoading] = useState(false);
    const [filterPopupSnapshot, setFilterPopupSnapshot] = useState(null);
    const [filterPopupSeries, setFilterPopupSeries] = useState([]);
    const [seriesOptions, setSeriesOptions] = useState([]);
    const [seriesLoading, setSeriesLoading] = useState(false);
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [pendingDeleteIds, setPendingDeleteIds] = useState([]);
    const [deleting, setDeleting] = useState(false);
    const [exportExcelEnabled, setExportExcelEnabled] = useState(false);
    const [masterReportData, setMasterReportData] = useState([]);
    const [detailsReportData, setDetailsReportData] = useState([]);
    const [reportLoading, setReportLoading] = useState(false);

    // 🔥 Add loading state hooks for unified loading display
    const { showLoadingSpinner, showEmptyState } = useDataLoadingState(loading, orders?.length > 0);
    const { showLoadingSpinner: showPendingSpinner, showEmptyState: showPendingEmpty } = useDataLoadingState(loadingPending, pendingOrders?.length > 0);
    const { showLoadingSpinner: showChallanSpinner, showEmptyState: showChallanEmpty } = useDataLoadingState(challanLoading, challanRows?.length > 0);

    // PDF states
    const [pdfUri, setPdfUri] = useState(null);
    const [pdfLoading, setPdfLoading] = useState(false);
    const [pdfError, setPdfError] = useState(null);
    const [pdfOverlayVisible, setPdfOverlayVisible] = useState(false);
    const [isGeneratingPdf, setIsGeneratingPdf] = useState(false);
    const [menuAnchorEl, setMenuAnchorEl] = useState(null);
    const [menuRowData, setMenuRowData] = useState(null);

    //states for e-way bill dialog
    const [ewayDialogOpen, setEwayDialogOpen] = useState(false);
    const [ewayDialogMounted, setEwayDialogMounted] = useState(false);
    const [ewayInvoiceId, setEwayInvoiceId] = useState(null);
    const [ewayBookName, setEwayBookName] = useState(null);

    // Search filter
    const [filterText, setFilterText] = useState('');

    const newWinRef = useRef(null);
    const revokeIntervalRef = useRef(null);

    const params = { userId, userCategory: role, companyId };

    const handleMenuOpen = (event, row) => {
        event.stopPropagation();
        setMenuAnchorEl(event.currentTarget);
        setMenuRowData(row);
    };

    const handleMenuClose = () => {
        setMenuAnchorEl(null);
        setMenuRowData(null);
    };

    // const handleEwayBillFromMenu = () => {
    //     if (!menuRowData?.ChallanAutoID) return;
    //     navigate("/main/EwayBill", {
    //         state: {
    //             invoiceId: menuRowData.ChallanAutoID,
    //             bookName: "SACH"
    //         }
    //     });
    //     handleMenuClose();
    // };

    // Open → mount first, then open
    const openEwayDialog = () => {
        setEwayDialogMounted(true);
        setEwayDialogOpen(true);
    };

    // Close → close first, unmount after animation ends
    const closeEwayDialog = () => {
        setEwayDialogOpen(false);
        setTimeout(() => setEwayDialogMounted(false), 300); // matches MUI default transition
    };

    const handleEwayBillFromMenu = () => {
        if (!menuRowData?.ChallanAutoID) return;
        setEwayInvoiceId(menuRowData.ChallanAutoID);
        setEwayBookName("SACH");
        openEwayDialog();   // ← use new handler
        handleMenuClose();
    };

    // Cleanup on unmount
    useEffect(() => {
        return () => {
            if (revokeIntervalRef.current) clearInterval(revokeIntervalRef.current);
            if (pdfUri) URL.revokeObjectURL(pdfUri);
            if (newWinRef.current && !newWinRef.current.closed) newWinRef.current.close();
        };
    }, [pdfUri]);

    // Fetch orders
    useEffect(() => {
        (async () => {
            setLoading(true);
            try {
                const res = await axios.get(`${API_URL}/orders`, {
                    params: { ...params, mode: "ref", bookName: "S-CH" },
                    headers: { 'Cache-Control': 'no-store' }
                });
                const raw = Array.isArray(res.data) ? res.data : [];
                console.log(res.data);
                const rows = raw.map(r => {
                    const soId = r.SOId ?? r.SOAutoID ?? r.id;
                    return {
                        ...r,
                        id: String(soId),
                        SOId: Number(soId),
                        SOAutoID: Number(soId),
                        BillAmt: Number(r.BillAmt) || 0,
                    };
                });
                setOrders(formatRows(rows));
                setPendingOrders(formatRows(rows));
            } catch (err) {
                console.error('❌ Failed to fetch orders', err);
                setOrders([]);
                setPendingOrders([]);
            } finally {
                setLoading(false);
                setLoadingPending(false);
            }
        })();
    }, []);

    // Fetch challans
    useEffect(() => {
        (async function fetchChallans() {
            try {
                const res = await axios.get(`${API_URL}/dispatch-challans`, { params });
                const data = Array.isArray(res.data) ? res.data : [];
                const rows = data.map((row, idx) => ({
                    id: row.ChallanId ?? idx,
                    ChallanAutoID: row.ChallanId,
                    BookTypeId: row.BookTypeId ?? null,
                    ChallanNumber: row.ChallanNumber,
                    RefNo: row.RefNo,
                    ChallanDate: row.ChallanDate ? new Date(row.ChallanDate).toLocaleDateString('en-GB') : '',
                    clientname: row.FirmName,
                    contactPerson: row.ContactPerson,
                    mobileNo: row.MobileNo,
                    city: row.City,
                    state: row.state,
                    BillAmt: Number(row.BillAmt) || 0,
                    clientId: row.PartyID,
                }));
                setChallanRows(formatRows(rows));
            } catch (err) {
                console.error('Error fetching challans:', err);
            } finally {
                setChallanLoading(false);
            }
        })();
    }, []);

    const handleTogglePending = () => setShowPending(prev => !prev);

    const handleDispatch = () => {
        if (selectedRows.length === 0) return;
        const firstOrder = selectedRows[0];
        const selectedSOIDs = selectedRows.map(r => r.SOAutoID);
        navigate(`/main/v3/challanMaster-stepper-ref/${firstOrder.clientId}`, { state: { selectedSOIDs } });
    };

    // const handleView = async (challanAutoID) => {
    //     if (isGeneratingPdf) return;
    //     setPdfOverlayVisible(true);
    //     setIsGeneratingPdf(true);
    //     setPdfError(null);
    //     setPdfUri(null);

    //     if (!challanAutoID) {
    //         setPdfOverlayVisible(false);
    //         setIsGeneratingPdf(false);
    //         return;
    //     }

    //     const userIdSafe = userId || 'usr1';
    //     let formatId = 'format_1';
    //     let bookNameToSend = 'SaleChallan';
    //     let bookIdToSend = null;
    //     let selectedSeriesId = null;

    //     try {
    //         const found = challanRows.find(c => Number(c.ChallanAutoID) === Number(challanAutoID));
    //         if (found?.BookName) bookNameToSend = String(found.BookName).trim();
    //         else if (found?.bookName) bookNameToSend = String(found.bookName).trim();

    //         selectedSeriesId = Number(found?.BookTypeId || 0) || null;
    //     } catch (e) { }

    //     try {
    //         const resp = await axios.get(`${API_URL}/companies`, { params: { companyId } });
    //         const comps = Array.isArray(resp?.data?.companies) ? resp.data.companies :
    //             Array.isArray(resp?.data) ? resp.data : [resp.data].filter(Boolean);

    //         const eq = (a, b) => String(a ?? '').trim().toLowerCase() === String(b ?? '').trim().toLowerCase();
    //         let matched = null;

    //         // for (const c of comps) {
    //         //     if (Array.isArray(c.formats)) {
    //         //         for (const f of c.formats) {
    //         //             const fBookName = f.BookName || f.bookName;
    //         //             const fFormName = f.FormName || f.formName;
    //         //             const fSeriesId = Number(f.SeriesId || f.seriesId || 0);

    //         //             if (
    //         //                 eq(fBookName, bookNameToSend) &&
    //         //                 Number(selectedSeriesId || 0) > 0 &&
    //         //                 fSeriesId === Number(selectedSeriesId)
    //         //             ) {
    //         //                 matched = f;
    //         //                 break;
    //         //             }
    //         //         }

    //         //         // fallback old logic if no series-specific match found
    //         //         if (!matched) {
    //         //             for (const f of c.formats) {
    //         //                 const fBookName = f.BookName || f.bookName;
    //         //                 const fFormName = f.FormName || f.formName;

    //         //                 if (
    //         //                     eq(fBookName, bookNameToSend) ||
    //         //                     eq(fFormName, "Challan") ||
    //         //                     String(fFormName || '').toLowerCase().includes('challan')
    //         //                 ) {
    //         //                     matched = f;
    //         //                     break;
    //         //                 }
    //         //             }
    //         //         }

    //         //         if (matched) break;
    //         //     }

    //         //     if (eq(c.BookName || c.bookName, bookNameToSend)) {
    //         //         matched = c;
    //         //         break;
    //         //     }
    //         // }

    //         for (const c of comps) {
    //             if (Array.isArray(c.formats)) {
    //                 for (const f of c.formats) {
    //                     const fBookName = f.BookName || f.bookName;
    //                     const fSeriesId = Number(f.SeriesId || f.seriesId || 0);

    //                     if (
    //                         eq(fBookName, bookNameToSend) &&
    //                         Number(selectedSeriesId || 0) > 0 &&
    //                         fSeriesId === Number(selectedSeriesId)
    //                     ) {
    //                         matched = f;
    //                         break;
    //                     }
    //                 }

    //                 if (matched) break;
    //             }
    //         }

    //         if (matched) {
    //             const id = matched.BookID ?? matched.BookId ?? matched.bookId;
    //             if (id) { formatId = `format_${id}`; bookIdToSend = id; }
    //             else if (matched.FormName || matched.formName) formatId = String(matched.FormName || matched.formName);
    //             bookNameToSend = matched.BookName || matched.bookName || bookNameToSend;
    //         }
    //     } catch (err) {
    //         console.warn("Format detection failed, using defaults");
    //     }

    //     try {
    //         setPdfLoading(true);

    //         const { data } = await axios.get(`${API_URL}/get-dispatch-data/${challanAutoID}`, {
    //             params: { companyId },
    //             headers: { 'Cache-Control': 'no-store' }
    //         });

    //         const { master, items = [], company } = data || {};
    //         if (!master) throw new Error("No master data returned");

    //         if (!selectedSeriesId) {
    //             selectedSeriesId = Number(master?.BookTypeId || 0) || null;
    //         }

    //         let imageBase64 = null;
    //         try {
    //             const iconRes = await axios.get(`${API_URL}/company/GetIcon/${companyId}`);
    //             if (iconRes?.data?.success && iconRes?.data?.imageBase64) {
    //                 imageBase64 = iconRes.data.imageBase64.replace(/^data:image\/\w+;base64,/, '');
    //             }
    //         } catch (e) { /* ignore */ }

    //         console.log(data);

    //         const transformedItems = items.map(d => ({
    //             ItemCode: d.itemCode || "",
    //             productImage: d.productImage || "",
    //             Remark: d.Remark || "",
    //             hsnCode: d.HSN || "",
    //             description: d.description || "",
    //             qty: Number(d.Qty) || 0,
    //             unit: d.Unit || "",
    //             rate: Number(d.Rate) || 0,
    //             discount: Number(d.Disc) || 0,
    //             cgst: Number(d.CGST) || 0,
    //             sgst: Number(d.SGST) || 0,
    //             igst: Number(d.IGST) || 0,
    //             amount: Number(d.ItemTotal) || 0,
    //         }));

    //         const pdfData = {
    //             companyId,
    //             companyName: master.clientDetails?.clientname || master.FirmName || "",
    //             address: master.clientDetails?.address || "",
    //             phone: master.clientDetails?.mobileNo || "",
    //             gstNo: master.clientDetails?.gstno || "",
    //             invoiceNo: master.ChallanNumber || "",
    //             referrenceNo: master.PartyPONO || "",
    //             date: master.ChallanDate ? normalizeDate(master.ChallanDate) : "",
    //             transport: "SELF",
    //             challanNo: master.ChallanNumber || "",
    //             poNo: master.PartyPONO || "",
    //             state: master.clientDetails?.state || "",
    //             stateCode: master.clientDetails?.stateCode || "",
    //             LrNo: master.ChallanNumber || "",
    //             vehNo: master.vehicleNumber || "",
    //             LrDate: master.DeliveryDate ? normalizeDate(master.DeliveryDate) : "",
    //             shipToGstNumber: master.clientDetails?.gstno || "",
    //             shipToState: master.clientDetails?.state || "",
    //             items: transformedItems,
    //             toEmail: master.clientDetails?.emailId || "",
    //             totalAmount: Number(master.BillAmt) || 0,
    //             mobileNo: master.clientDetails?.mobileNo || "",
    //             BasicAmt: Number(master.BasicAmt) || 0,
    //             CGSTAmt: Number(master.CGSTAmt) || 0,
    //             SGSTAmt: Number(master.SGSTAmt) || 0,
    //             IGSTAmt: Number(master.IGSTAmt) || 0,
    //             RoundOff: Number(master.RoundOff) || 0,
    //             BillAmt: Number(master.BillAmt) || 0,
    //             clientState: master.clientState || "",
    //             imageBase64: imageBase64 || null,
    //             Remark: master.Remark || null
    //         };

    //         const companyHeader = company ? {
    //             CompId: company.CompId,
    //             CompanyName: company.CompanyName || "",
    //             Address: company.Address || "",
    //             MobileNo: company.MobileNo || "",
    //             EmailId: company.EmailId || "",
    //             Website: company.Website || "",
    //             GSTNo: company.GSTNo || "",
    //             imageBase64: imageBase64 || null,
    //             city: company.City || null,
    //             BkName1: company.BkName1 || null,
    //             BkBranch1: company.BkBranch1 || null,
    //             BkAcNo1: company.BkAcNo1 || null,
    //             BkIFSCCode1: company.BkIFSCCode1 || null,
    //         } : null;

    //         const pdfResp = await axios.post(
    //             `${PDF_API_BASE}/api/pdf/Challan/${challanAutoID}`,
    //             {
    //                 docId: challanAutoID,
    //                 userId: userIdSafe,
    //                 formatId,
    //                 data: pdfData,
    //                 company: companyHeader
    //             },
    //             { responseType: "blob", timeout: 120000 }
    //         );

    //         const blob = pdfResp.data;
    //         if (!blob || blob.size === 0) throw new Error("Empty PDF");

    //         const blobUrl = URL.createObjectURL(new Blob([blob], { type: "application/pdf" }));

    //         // (old code : commented to implement pdf view in webview)
    //         // const newWin = window.open("", "_blank");
    //         // if (newWin) {
    //         //     newWinRef.current = newWin;
    //         //     newWin.location.href = blobUrl;
    //         //     newWin.focus();

    //         //     const checker = setInterval(() => {
    //         //         if (newWin.closed) {
    //         //             URL.revokeObjectURL(blobUrl);
    //         //             clearInterval(checker);
    //         //             newWinRef.current = null;
    //         //         }
    //         //     }, 1000);
    //         //     revokeIntervalRef.current = checker;
    //         // } else {
    //         //     if (pdfUri) URL.revokeObjectURL(pdfUri);
    //         //     setPdfUri(blobUrl);
    //         //     setSnackbarMessage("Popup blocked — showing PDF inline");
    //         //     setSnackbarSeverity("warning");
    //         //     setSnackbarOpen(true);
    //         // }

    //         // (new code : Added to handle pdf in web and mobile both using webview)
    //         if (window.ReactNativeWebView) {

    //             const reader = new FileReader();

    //             reader.onloadend = () => {
    //                 window.ReactNativeWebView.postMessage(
    //                     JSON.stringify({
    //                         type: "OPEN_PDF",
    //                         base64: reader.result
    //                     })
    //                 );
    //             };

    //             reader.readAsDataURL(blob);

    //         } else {

    //             const newWin = window.open("", "_blank");
    //             if (newWin) {
    //                 newWinRef.current = newWin;
    //                 newWin.location.href = blobUrl;
    //                 newWin.focus();

    //                 const checker = setInterval(() => {
    //                     if (newWin.closed) {
    //                         URL.revokeObjectURL(blobUrl);
    //                         clearInterval(checker);
    //                         newWinRef.current = null;
    //                     }
    //                 }, 1000);
    //                 revokeIntervalRef.current = checker;
    //             } else {
    //                 if (pdfUri) URL.revokeObjectURL(pdfUri);
    //                 setPdfUri(blobUrl);
    //                 setSnackbarMessage("Popup blocked — showing PDF inline");
    //                 setSnackbarSeverity("warning");
    //                 setSnackbarOpen(true);
    //             }

    //         }

    //     } catch (err) {
    //         console.error("Challan PDF Error:", err);
    //         setPdfError("Failed to generate Challan PDF");
    //         setSnackbarMessage("Could not load PDF. Please try again.");
    //         setSnackbarSeverity("error");
    //         setSnackbarOpen(true);
    //     } finally {
    //         setPdfOverlayVisible(false);
    //         setIsGeneratingPdf(false);
    //         setPdfLoading(false);
    //     }
    // };

    const handleView = async (challanAutoID) => {
        if (isGeneratingPdf) return;
        setPdfOverlayVisible(true);
        setIsGeneratingPdf(true);
        setPdfError(null);
        setPdfUri(null);

        if (!challanAutoID) {
            setPdfOverlayVisible(false);
            setIsGeneratingPdf(false);
            return;
        }

        const userIdSafe = userId || 'usr1';
        let formatId = 'format_1';
        let bookNameToSend = 'SaleChallan';
        let bookIdToSend = null;
        let selectedSeriesId = null;
        let pageSize = 'A5'; // ✅ NEW: Default to A5

        try {
            const found = challanRows.find(c => Number(c.ChallanAutoID) === Number(challanAutoID));
            if (found?.BookName) bookNameToSend = String(found.BookName).trim();
            else if (found?.bookName) bookNameToSend = String(found.bookName).trim();

            selectedSeriesId = Number(found?.BookTypeId || 0) || null;
        } catch (e) { }

        let matchedFormat = null;
        try {
            // ✅ Add cache-buster to get fresh data
            const cacheBreaker = new Date().getTime();
            const resp = await axios.get(`${API_URL}/companies`, { params: { companyId, t: cacheBreaker } });
            const comps = Array.isArray(resp?.data?.companies) ? resp.data.companies :
                Array.isArray(resp?.data) ? resp.data : [resp.data].filter(Boolean);

            const eq = (a, b) => String(a ?? '').trim().toLowerCase() === String(b ?? '').trim().toLowerCase();
            let matched = null;

            for (const c of comps) {
                if (Array.isArray(c.formats)) {
                    for (const f of c.formats) {
                        const fBookName = f.BookName || f.bookName;
                        const fSeriesId = Number(f.SeriesId || f.seriesId || 0);

                        if (
                            eq(fBookName, bookNameToSend) &&
                            Number(selectedSeriesId || 0) > 0 &&
                            fSeriesId === Number(selectedSeriesId)
                        ) {
                            matched = f;
                            break;
                        }
                    }

                    if (matched) break;
                }
            }

            if (matched) {
                const id = matched.BookID ?? matched.BookId ?? matched.bookId;
                if (id) { formatId = `format_${id}`; bookIdToSend = id; }
                else if (matched.FormName || matched.formName) formatId = String(matched.FormName || matched.formName);
                bookNameToSend = matched.BookName || matched.bookName || bookNameToSend;

                // ✅ NEW: Extract PageSize from matched format (default A5 if not present)
                if (matched.PageSize) {
                    pageSize = matched.PageSize === 'A4' ? 'A4' : 'A5';
                }
                // ✅ Store matched format for Signature checking (fresh from API)
                matchedFormat = matched;
            }
        } catch (err) {
            console.warn("Format detection failed, using defaults");
        }

        try {
            setPdfLoading(true);

            const { data } = await axios.get(`${API_URL}/get-dispatch-data/${challanAutoID}`, {
                params: { companyId },
                headers: { 'Cache-Control': 'no-store' }
            });

            const { master, items = [], company, termsAndConditions, additionalChargeItems } = data || {};
            if (!master) throw new Error("No master data returned");

            console.log("🌐 API Response data:", data);
            console.log("📦 Master object keys:", Object.keys(master));
            console.log("🎯 additionalChargeItems from API:", additionalChargeItems);
            console.log("💾 Checking master for Adc fields:", {
                Adc1Amt: master.Adc1Amt,
                Adc2Amt: master.Adc2Amt,
                Adc3Amt: master.Adc3Amt,
                Adc4Amt: master.Adc4Amt,
                Adc5Amt: master.Adc5Amt,
            });


            const termsText = Array.isArray(termsAndConditions) && termsAndConditions.length > 0
                ? termsAndConditions
                    .sort((a, b) => a.SrNo - b.SrNo)
                    .map(t => `# ${t.TermsDescription}`)
                    .join('\n')
                : null;

            if (!selectedSeriesId) {
                selectedSeriesId = Number(master?.BookTypeId || 0) || null;
            }

            let imageBase64 = null;
            let signatureBase64 = null;
            try {
                const iconRes = await axios.get(`${API_URL}/company/GetIcon/${companyId}`);
                if (iconRes?.data?.success && iconRes?.data?.imageBase64) {
                    imageBase64 = iconRes.data.imageBase64.replace(/^data:image\/\w+;base64,/, '');
                }
                if (iconRes?.data?.signatureBase64) {
                    signatureBase64 = iconRes.data.signatureBase64;
                }
            } catch (e) { /* ignore */ }
            // ✅ Use matched format's Signature (fresh from API, not cached context)
            if (!matchedFormat?.Signature) signatureBase64 = null;

            // ✅ Build additional charges from master data
            // The Adc1Amt, Adc2Amt, etc. are stored in challan master table
            const allPossibleCharges = [1, 2, 3, 4, 5]
                .map(slot => {
                    const chargeItem = (additionalChargeItems || []).find(ci => Number(ci.TransType) === 199 + slot);

                    // Primary: Try standard column name (case-sensitive as stored in DB)
                    let amount = Number(master[`Adc${slot}Amt`]) || 0;

                    // Fallback 1: Try alternative casing variations
                    if (amount === 0 || isNaN(amount)) {
                        amount = Number(master[`ADC${slot}Amt`]) || 0;
                    }
                    if (amount === 0 || isNaN(amount)) {
                        amount = Number(master[`adc${slot}Amt`]) || 0;
                    }

                    // Fallback 2: Try alternative column names
                    if (amount === 0 || isNaN(amount)) {
                        amount = Number(master[`AdditionalCharge${slot}`]) || 0;
                    }
                    if (amount === 0 || isNaN(amount)) {
                        amount = Number(master[`Charge${slot}Amount`]) || 0;
                    }

                    // Ensure amount is a valid number
                    amount = isNaN(amount) ? 0 : Math.max(0, amount);

                    return {
                        name: chargeItem?.description || `Charge ${slot}`,
                        amount: amount,
                    };
                });

            // Only include charges with amount > 0
            const additionalCharges = allPossibleCharges.filter(c => c.amount > 0);

            // ✅ Debugging logs
            console.log("📋 Master keys containing 'Adc':", Object.keys(master).filter(k => k.toLowerCase().includes('adc')));
            console.log("🔢 Adc amounts found:", {
                Adc1Amt: master.Adc1Amt,
                Adc2Amt: master.Adc2Amt,
                Adc3Amt: master.Adc3Amt,
                Adc4Amt: master.Adc4Amt,
                Adc5Amt: master.Adc5Amt,
            });
            console.log("🎯 additionalChargeItems from API:", additionalChargeItems);
            console.log("🎯 All possible charges (before filter):", allPossibleCharges);
            console.log("✅ Final additionalCharges (after filter):", additionalCharges);
            console.log("📊 JSON:", JSON.stringify(additionalCharges, null, 2));

            
            const transformedItems = items.map(d => ({
                ItemCode: d.itemCode || "",
                productImage: d.productImage || "",
                Remark: d.Remark || "",
                hsnCode: d.HSN || "",
                description: d.description || "",
                qty: Number(d.Qty) || 0,
                unit: d.Unit || "",
                rate: Number(d.Rate) || 0,
                discount: Number(d.Disc) || 0,
                cgst: Number(d.CGST) || 0,
                sgst: Number(d.SGST) || 0,
                igst: Number(d.IGST) || 0,
                amount: Number(d.ItemTotal) || 0,
                TaxableAmt: Number(d.TaxableAmt) || 0,
            }));
            console.log(transformedItems);

            const pdfData = {
                companyId,
                companyName: master.clientDetails?.clientname || master.FirmName || "",
                address: master.clientDetails?.address || "",
                phone: master.clientDetails?.mobileNo || "",
                gstNo: master.clientDetails?.gstno || "",
                invoiceNo: master.ChallanNumber || "",
                referrenceNo: master.PartyPONO || "",
                date: master.ChallanDate ? normalizeDate(master.ChallanDate) : "",
                transport: "SELF",
                challanNo: master.ChallanNumber || "",
                poNo: master.PartyPONO || "",
                state: master.clientDetails?.state || "",
                stateCode: master.clientDetails?.stateCode || "",
                LrNo: master.ChallanNumber || "",
                vehNo: master.vehicleNumber || "",
                additionalCharges,
                LrDate: master.DeliveryDate ? normalizeDate(master.DeliveryDate) : "",
                shipToGstNumber: master.clientDetails?.gstno || "",
                shipToState: master.clientDetails?.state || "",
                items: transformedItems,
                toEmail: master.clientDetails?.emailId || "",
                totalAmount: Number(master.BillAmt) || 0,
                mobileNo: master.clientDetails?.mobileNo || "",
                BasicAmt: Number(master.TaxableAmt) || 0,
                CGSTAmt: Number(master.CGSTAmt) || 0,
                SGSTAmt: Number(master.SGSTAmt) || 0,
                IGSTAmt: Number(master.IGSTAmt) || 0,
                RoundOff: Number(master.RoundOff) || 0,
                BillAmt: Number(master.BillAmt) || 0,
                clientState: master.clientState || "",
                imageBase64: imageBase64 || null,
                Remark: master.Remark || null,
                termsAndConditions: termsText,
                PaymentTerm: master.PaymentTerm || null,
            };
            console.log("📤 Sending PDF Request - pdfData:", pdfData);

            const companyHeader = company ? {
                CompId: company.CompId,
                CompanyName: company.CompanyName || "",
                Address: company.Address || "",
                MobileNo: company.MobileNo || "",
                EmailId: company.EmailId || "",
                Website: company.Website || "",
                GSTNo: company.GSTNo || "",
                imageBase64: imageBase64 || null,
                signatureBase64: signatureBase64 || null,
                headerColor: matchedFormat?.Color || themeColors.neutral.black,
                city: company.City || null,
                BkName1: company.BkName1 || null,
                BkBranch1: company.BkBranch1 || null,
                BkAcNo1: company.BkAcNo1 || null,
                BkIFSCCode1: company.BkIFSCCode1 || null,
            } : null;


            const pdfResp = await axios.post(
                `${PDF_API_BASE}/api/pdf/Challan/${challanAutoID}`,
                {
                    docId: challanAutoID,
                    userId: userIdSafe,
                    formatId,
                    data: pdfData,
                    company: companyHeader,
                    pageSize: pageSize // ✅ NEW: Send pageSize to backend
                },
                { responseType: "blob", timeout: 120000 }
            );
            console.log("✅ PDF Response received, size:", pdfResp.data.size);

            const blob = pdfResp.data;
            if (!blob || blob.size === 0) throw new Error("Empty PDF");

            const blobUrl = URL.createObjectURL(new Blob([blob], { type: "application/pdf" }));

            // (old code : commented to implement pdf view in webview)
            // const newWin = window.open("", "_blank");
            // if (newWin) {
            //     newWinRef.current = newWin;
            //     newWin.location.href = blobUrl;
            //     newWin.focus();

            //     const checker = setInterval(() => {
            //         if (newWin.closed) {
            //             URL.revokeObjectURL(blobUrl);
            //             clearInterval(checker);
            //             newWinRef.current = null;
            //         }
            //     }, 1000);
            //     revokeIntervalRef.current = checker;
            // } else {
            //     if (pdfUri) URL.revokeObjectURL(pdfUri);
            //     setPdfUri(blobUrl);
            //     setSnackbarMessage("Popup blocked — showing PDF inline");
            //     setSnackbarSeverity("warning");
            //     setSnackbarOpen(true);
            // }

            // (new code : Added to handle pdf in web and mobile both using webview)
            if (window.ReactNativeWebView) {

                const reader = new FileReader();

                reader.onloadend = () => {
                    window.ReactNativeWebView.postMessage(
                        JSON.stringify({
                            type: "OPEN_PDF",
                            base64: reader.result
                        })
                    );
                };

                reader.readAsDataURL(blob);

            } else {

                const newWin = window.open("", "_blank");
                if (newWin) {
                    newWinRef.current = newWin;
                    newWin.location.href = blobUrl;
                    newWin.focus();

                    const checker = setInterval(() => {
                        if (newWin.closed) {
                            URL.revokeObjectURL(blobUrl);
                            clearInterval(checker);
                            newWinRef.current = null;
                        }
                    }, 1000);
                    revokeIntervalRef.current = checker;
                } else {
                    if (pdfUri) URL.revokeObjectURL(pdfUri);
                    setPdfUri(blobUrl);
                    setSnackbarMessage("Popup blocked — showing PDF inline");
                    setSnackbarSeverity("warning");
                    setSnackbarOpen(true);
                }

            }

        } catch (err) {
            console.error("Challan PDF Error:", err);
            setPdfError("Failed to generate Challan PDF");
            setSnackbarMessage("Could not load PDF. Please try again.");
            setSnackbarSeverity("error");
            setSnackbarOpen(true);
        } finally {
            setPdfOverlayVisible(false);
            setIsGeneratingPdf(false);
            setPdfLoading(false);
        }
    };

    const handleChallanDelete = (objAryId) => {
        if (!objAryId?.length) {
            setSnackbarMessage('No challans selected.');
            setSnackbarSeverity('warning');
            setSnackbarOpen(true);
            return;
        }

        setPendingDeleteIds(objAryId);
        setOpenDeleteDialog(true);
    };

    const confirmChallanDelete = async () => {
        // if (!objAryId.length || !window.confirm(`Are you sure you want to delete ${objAryId.length} challan(s)?`)) return;
        if (deleting) return;
        const numericIds = pendingDeleteIds.map(Number);
        setDeleting(true);
        try {
            const payload = { objAryId: numericIds, companyId };
            const { data } = await axios.post(`${API_URL}/delete-challans`, payload);
            console.log(data);
            // if (totalDeleted > 0) {
            //     setChallanRows(prev =>
            //         prev.filter(row =>
            //             !deletedIds.includes(Number(row.ChallanAutoID))
            //         )
            //     );
            //     setChallanSelectionModel(prev => prev.filter(id => !numericIds.includes(id)));
            //     setSnackbarMessage(`Deleted successfully.`);
            //     setSnackbarSeverity('success');
            // } else if (data.referencedIds && data.referencedIds.length > 0) {
            //     setSnackbarMessage(data.message || 'Some challans have references.');
            //     setSnackbarSeverity('warning');
            // } else {
            //     setSnackbarMessage('No challans were deleted.');
            //     setSnackbarSeverity('info');
            // }

            const deletedIds = (data.deletedIds || []).map(Number);
            const referencedIds = (data.referencedIds || []).map(Number);

            // ✅ 1. REMOVE deleted challans from UI immediately
            if (deletedIds.length > 0) {
                setChallanRows(prev =>
                    prev.filter(
                        row => !deletedIds.includes(Number(row.ChallanAutoID))
                    )
                );

                setChallanSelectionModel(prev =>
                    prev.filter(id => !deletedIds.includes(Number(id)))
                );
            }

            // ✅ 2. CORRECT challan count (NOT DB rows)
            const deletedCount = deletedIds.length;

            // ✅ Show deleted count
            if (deletedCount > 0) {
                setSnackbarMessage("Deleted Successfully.");
                setSnackbarSeverity("success");
                setSnackbarOpen(true);
            }

            // ⚠️ Show referenced IDs clearly
            if (referencedIds.length > 0 && deletedCount <= 0) {
                setSnackbarMessage("Cannot delete the selected item(s) because they are referenced in other records.");
                setSnackbarSeverity("warning");
                setSnackbarOpen(true);
            }
        } catch (err) {
            console.error('Error deleting challans:', err);
            setSnackbarMessage(`Failed: ${err.response?.data?.message || err.message}`);
            setSnackbarSeverity('error');
            setSnackbarOpen(true);
        } finally {
            setDeleting(false);
            setOpenDeleteDialog(false);
            setPendingDeleteIds([]);
        }
    };

    // Filtered data
    const filteredPendingOrders = useMemo(() => {
        if (!filterText) return pendingOrders;
        const lower = filterText.toLowerCase();
        return pendingOrders.filter(row =>
            String(row.SONumber || "").toLowerCase().includes(lower) ||
            String(row.PartyName || "").toLowerCase().includes(lower)
        );
    }, [pendingOrders, filterText]);

    const filteredChallans = useMemo(() => {
        if (!filterText) return challanRows;
        const lower = filterText.toLowerCase();
        return challanRows.filter(row =>
            String(row.ChallanNumber || "").toLowerCase().includes(lower) ||
            String(row.clientname || "").toLowerCase().includes(lower)
        );
    }, [challanRows, filterText]);

    // === Mobile Card Renderers (Redesigned) ===

    const renderPendingOrderCards = () => {

        return filteredPendingOrders.map((row) => {
            const isSelected = selectedRowIds.includes(Number(row.SOId));
            const avatarColor = stringToColor(row.PartyName || 'Order');
            const initials = getInitials(row.PartyName);
            const locationText = [row.City, row.state].filter(Boolean).join(', ') || '—';

            const toggleSelection = (e) => {
                e.stopPropagation();
                setSelectedRows(prevRows => {
                    const prevClientId = prevRows.length > 0 ? String(prevRows[0].clientId ?? '') : null;
                    const rowClientId = String(row.clientId ?? '');
                    if (prevClientId && rowClientId !== prevClientId) {
                        setSnackbarMessage('Client mismatch — select only from same client.');
                        setSnackbarSeverity('warning');
                        setSnackbarOpen(true);
                        return prevRows;
                    }
                    const exists = prevRows.some(r => Number(r.SOId) === Number(row.SOId));
                    const newRows = exists ? prevRows.filter(r => Number(r.SOId) !== Number(row.SOId)) : [...prevRows, row];
                    setSelectedRowIds(newRows.map(r => Number(r.SOId)));
                    return newRows;
                });
            };

            return (
                <Card key={row.SOId} sx={{ mb: 2, borderLeft: `6px solid ${themeColors.warning.main}`, borderRadius: 2, overflow: 'hidden', boxShadow: 3, bgcolor: 'background.paper' }} >
                    <CardContent sx={{ p: 2 }}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', flex: 1 }}>
                                <Checkbox checked={isSelected} onChange={toggleSelection} size="small" />
                                <Avatar sx={{ bgcolor: avatarColor, color: themeColors.neutral.surface, width: 36, height: 36, ml: 1 }}>
                                    <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: themeColors.neutral.surface }}>{initials}</Typography>
                                </Avatar>
                                <Box sx={{ ml: 1.5, flex: 1 }}>
                                    <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                                        {row.PartyName || 'N/A'}
                                    </Typography>
                                    <Typography variant="caption" color="text.secondary">
                                        {locationText}
                                    </Typography>
                                </Box>
                            </Box>
                            <Typography variant="caption" color="text.secondary" sx={{ minWidth: 80, textAlign: 'right' }}>
                                {normalizeDate(row.SODate)}
                            </Typography>
                        </Box>

                        <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 1 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                <DescriptionIcon sx={{ fontSize: 18, color: 'text.secondary', mr: 1 }} />
                                <Typography variant="body2" color="text.secondary">
                                    {row.SONumber || 'N/A'}
                                </Typography>
                            </Box>
                            <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                                ₹{row.BillAmt.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                            </Typography>
                        </Box>

                        {(row.ContactPerson || row.MobileNo) && (
                            <>
                                <Divider sx={{ my: 1.5 }} />
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                        <PersonIcon sx={{ fontSize: 18, color: 'text.secondary', mr: 1 }} />
                                        <Typography variant="body2" color="text.secondary">
                                            {row.ContactPerson || 'N/A'}
                                        </Typography>
                                    </Box>
                                    {row.MobileNo && (
                                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                            <PhoneIcon sx={{ fontSize: 18, color: 'text.secondary', mr: 1 }} />
                                            <Typography variant="body2" color="text.secondary">
                                                {row.MobileNo}
                                            </Typography>
                                        </Box>
                                    )}
                                </Box>
                            </>
                        )}
                    </CardContent>
                </Card>
            );
        });
    };

    const renderChallanCards = () => {

        return filteredChallans.map((row) => {
            const isSelected = challanSelectionModel.includes(Number(row.ChallanAutoID));
            const avatarColor = stringToColor(row.clientname || 'Challan');
            const initials = getInitials(row.clientname);
            const locationText = [row.city, row.state].filter(Boolean).join(', ') || '—';

            const hasReference = Boolean(row.RefNo);

            return (
                <Card
                    key={row.ChallanAutoID}
                    onClick={() => navigate(`/main/v3/challanMaster-edit/${row.ChallanAutoID}`, { state: { clientId: row.clientId } })}
                    sx={{
                        mb: 2,
                        borderLeft: `6px solid ${hasReference ? themeColors.warning.main : themeColors.primary.main}`,
                        borderRadius: 2,
                        overflow: 'hidden',
                        boxShadow: 3,
                        bgcolor: 'background.paper',
                        cursor: 'pointer',
                        '&:hover': { boxShadow: 6 }
                    }}
                >
                    <CardContent sx={{ p: 2 }}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', flex: 1 }}>
                                {role !== 'User' && (
                                    <Checkbox
                                        checked={isSelected}
                                        onChange={() => {
                                            setChallanSelectionModel(prev =>
                                                prev.includes(Number(row.ChallanAutoID))
                                                    ? prev.filter(id => id !== Number(row.ChallanAutoID))
                                                    : [...prev, Number(row.ChallanAutoID)]
                                            );
                                        }}
                                        onClick={(e) => e.stopPropagation()}
                                        size="small"
                                    />
                                )}
                                <Avatar sx={{ bgcolor: avatarColor, color: themeColors.neutral.surface, width: 36, height: 36, ml: 1 }}>
                                    <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: themeColors.neutral.surface }}>{initials}</Typography>
                                </Avatar>
                                <Box sx={{ ml: 1.5, flex: 1 }}>
                                    <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                                        {row.clientname || 'N/A'}
                                    </Typography>
                                    <Typography variant="caption" color="text.secondary">
                                        {locationText}
                                    </Typography>
                                </Box>
                            </Box>
                            <Typography variant="caption" color="text.secondary" sx={{ minWidth: 80, textAlign: 'right' }}>
                                {row.ChallanDate || '—'}
                            </Typography>
                        </Box>

                        <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 1 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                <DescriptionIcon sx={{ fontSize: 18, color: 'text.secondary', mr: 1 }} />
                                <Typography
                                    variant="body2"
                                    sx={{ color: 'primary.main', textDecoration: 'underline' }}
                                >
                                    {row.ChallanNumber || 'N/A'}
                                </Typography>
                            </Box>
                            <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                                ₹{row.BillAmt.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                            </Typography>
                        </Box>

                        {/* {row.RefNo && (
                            <Box sx={{ display: 'flex', alignItems: 'center', mt: 0.5 }}>
                                <LinkIcon sx={{ fontSize: 18, color: 'text.secondary', mr: 1 }} />
                                <Typography variant="body2" color="text.secondary">
                                    {row.RefNo}
                                </Typography>
                            </Box>
                        )} */}


                        {/* Reference Chip */}
                        <Box sx={{ mb: 0.8 }}>
                            {hasReference ? (
                                <Chip
                                    label={`Ref: ${row.RefNo}`}
                                    size="small"
                                    sx={{
                                        bgcolor: themeColors.warning.tint,
                                        color: '#E65100',
                                        fontWeight: 500
                                    }}
                                />
                            ) : (
                                <Chip
                                    label="Manual"
                                    size="small"
                                    sx={{ bgcolor: '#e7f5ff', color: "#0067bb" }}
                                />
                            )}
                        </Box>

                        <Divider sx={{ my: 1 }} />

                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                            }}
                        >
                            {/* Left Side */}
                            <Box sx={{ display: 'flex', alignItems: 'center', flex: 1 }}>
                                {(row.contactPerson || row.mobileNo) && (
                                    <>
                                        <PersonIcon
                                            sx={{ fontSize: 18, color: 'text.secondary', mr: 1 }}
                                        />

                                        <Typography
                                            variant="body2"
                                            color="text.secondary"
                                            noWrap
                                        >
                                            {row.contactPerson || row.mobileNo || 'N/A'}
                                        </Typography>
                                    </>
                                )}
                            </Box>

                            {/* Right Side */}
                            <Box sx={{ display: 'flex', gap: 0.5, flexShrink: 0 }}>
                                <IconButton
                                    color="primary"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleView(row.ChallanAutoID);
                                    }}
                                    size="small"
                                >
                                    <PrintIcon fontSize="small" />
                                </IconButton>

                                <IconButton
                                    size="small"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleMenuOpen(e, row);
                                    }}
                                >
                                    <MoreVertIcon fontSize="small" />
                                </IconButton>
                            </Box>
                        </Box>

                        {/* {(row.contactPerson || row.mobileNo) && (
                            <>
                                <Divider />
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                        <PersonIcon sx={{ fontSize: 18, color: 'text.secondary', mr: 1 }} />
                                        <Typography variant="body2" color="text.secondary">
                                            {row.contactPerson || 'N/A'}
                                        </Typography>
                                    </Box>
                                    <Box sx={{ display: 'flex', gap: 0.5 }}>
                                        <IconButton color="primary" onClick={(e) => { e.stopPropagation(); handleView(row.ChallanAutoID); }} size="small">
                                            <PrintIcon />
                                        </IconButton>
                                        <IconButton
                                            size="small"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleMenuOpen(e, row);
                                            }}
                                        >
                                            <MoreVertIcon fontSize="small" />
                                        </IconButton>
                                    </Box>
                                </Box>
                            </>
                        )} */}
                    </CardContent>
                </Card>
            );
        });
    };

    // === Original Columns (for desktop) ===
    const columns = useMemo(() => [
        {
            field: 'select', headerName: '', width: 40, sortable: false, disableColumnMenu: true, filterable: false,
            renderHeader: () => {
                const referenceClientId = selectedRows.length > 0 ? String(selectedRows[0].clientId ?? '') : (pendingOrders[0] ? String(pendingOrders[0].clientId ?? '') : null);
                const eligibleRows = referenceClientId ? pendingOrders.filter(row => String(row.clientId ?? '') === referenceClientId) : [];
                const allSelected = eligibleRows.length > 0 && eligibleRows.every(row => selectedRowIds.includes(Number(row.SOId)));
                const someSelected = selectedRowIds.length > 0 && !allSelected;

                return (
                    <Checkbox checked={allSelected} indeterminate={someSelected} disabled={!referenceClientId}
                        onChange={(e) => {
                            if (e.target.checked) {
                                const newSelectedRows = eligibleRows.slice();
                                setSelectedRows(newSelectedRows);
                                setSelectedRowIds(newSelectedRows.map(r => Number(r.SOId)));
                            } else {
                                setSelectedRows([]);
                                setSelectedRowIds([]);
                            }
                        }}
                    />
                );
            },
            renderCell: ({ row }) => {
                const rowIdNum = Number(row.SOId);
                const checked = selectedRowIds.includes(rowIdNum);

                return (
                    <Checkbox checked={checked}
                        onChange={(e) => {
                            const checkedNow = e.target.checked;
                            setSelectedRows(prevRows => {
                                const prevClientId = prevRows.length > 0 ? String(prevRows[0].clientId ?? '') : null;
                                if (checkedNow) {
                                    const rowClientId = String(row.clientId ?? '');
                                    const effectiveClientId = prevClientId ?? rowClientId;
                                    if (prevClientId && rowClientId !== prevClientId) {
                                        setSnackbarMessage('Oops! Client name mismatch — select only orders from the same client.');
                                        setSnackbarSeverity('warning');
                                        setSnackbarOpen(true);
                                        return prevRows;
                                    }
                                    const already = prevRows.some(r => String(r.SOId) === String(row.SOId));
                                    if (already) return prevRows;
                                    const newRows = [...prevRows, row];
                                    setSelectedRowIds(newRows.map(r => Number(r.SOId)));
                                    return newRows;
                                } else {
                                    const newRows = prevRows.filter(r => Number(r.SOId) !== rowIdNum);
                                    setSelectedRowIds(newRows.map(r => Number(r.SOId)));
                                    return newRows;
                                }
                            });
                        }}
                    />
                );
            },
        },
        { field: 'SODate', headerName: 'SO Date', flex: 0.8, filterable: true, valueGetter: (value) => normalizeDate(value), valueFormatter: (p) => normalizeDate(p) },
        { field: "SONumber", headerName: "SO No.", flex: 1.2 },
        { field: 'PartyPONO', headerName: 'Ref No.', flex: 1, },
        {
            field: 'PartyName', headerName: 'FirmName', flex: 2.5,
            renderCell: (params) => (
                <Box sx={{ whiteSpace: 'normal', wordBreak: 'break-word', my: 1 }}>
                    <Typography variant='subtitle2' sx={{ fontSize: '0.85rem' }}>{params.row.PartyName || '-'}</Typography>
                    <Stack direction='row' alignItems='center' spacing={1}>
                        <FaUser color={themeColors.warning.main} />
                        <Typography variant='body2'>{params.row.ContactPerson || '-'}</Typography>
                    </Stack>
                    <Typography variant='body2' color='text.secondary'>📲 {params.row.MobileNo || '-'}</Typography>
                </Box>
            ),
        },
        {
            field: 'location', headerName: 'Location', flex: 1.5, filterable: true,
            valueGetter: (value, row) => [row.City, row.state].filter(Boolean).join(', '),
            renderCell: (params) => (
                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                    <Typography variant="body2">{params.row.City || '-'}</Typography>
                    <Typography variant="caption" color="text.secondary">{params.row.state || '-'}</Typography>
                </Box>
            ),
        },
        ...(role !== "SalesMan" ? [{ field: "BillAmt", headerName: "Total Amt", flex: 1, align: "right", headerAlign: "right", valueFormatter: (p) => `₹${Number(p || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` }] : []),
    ], [selectedRows, selectedRowIds, pendingOrders, role]);

    const challanColumns = useMemo(() => {
        let cols = [
            { field: 'ChallanDate', headerName: 'Date', flex: 0.8, filterable: true, },
            {
                field: 'ChallanNumber', headerName: 'Challan Number', flex: 1.2,
                renderCell: (params) => (
                    <Typography
                        variant="body2"
                        sx={{ color: 'blue', textDecoration: 'underline', cursor: 'pointer' }}
                        onClick={() => navigate(`/main/v3/challanMaster-edit/${params.row.ChallanAutoID}`, { state: { clientId: params.row.clientId } })}
                    >
                        {params.value ?? '-'}
                    </Typography>
                ),
            },
            { field: 'RefNo', headerName: 'Ref No.', flex: 1 },
            {
                field: 'clientname', headerName: 'FirmName', flex: 2.5,
                renderCell: (params) => (
                    <Box sx={{ whiteSpace: 'normal', wordBreak: 'break-word', my: 1 }}>
                        <Typography variant='subtitle2' sx={{ fontSize: '0.85rem' }}>{params.row.clientname || '-'}</Typography>
                        <Stack direction='row' alignItems='center' spacing={1}>
                            <FaUser color={themeColors.warning.main} />
                            <Typography variant='body2'>{params.row.contactPerson || '-'}</Typography>
                        </Stack>
                        <Typography variant='body2' color='text.secondary'>📲 {params.row.mobileNo || '-'}</Typography>
                    </Box>
                ),
            },
            {
                field: 'location', headerName: 'Location', flex: 1.5, filterable: true,
                valueGetter: (value, row) => [row.city, row.state].filter(Boolean).join(', '),
                renderCell: (params) => (
                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                        <Typography variant="body2">{params.row.city || '-'}</Typography>
                        <Typography variant="caption" color="text.secondary">{params.row.state || '-'}</Typography>
                    </Box>
                ),
            },
            {
                field: 'BillAmt', headerName: 'Total Amt', flex: 1, align: 'right', headerAlign: 'right',
                valueFormatter: (p) => `₹${Number(p || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
            },
            {
                field: 'actions', headerName: 'Action', flex: 0.8, align: 'right', headerAlign: 'right', filterable: false,
                renderCell: (params) => (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, justifyContent: 'flex-end' }}>
                        <IconButton color="primary" onClick={() => handleView(params.row.ChallanAutoID)} size="small">
                            <PrintIcon />
                        </IconButton>
                        <IconButton
                            size="small"
                            onClick={(e) => handleMenuOpen(e, params.row)}
                        >
                            <MoreVertIcon fontSize="small" />
                        </IconButton>
                    </Box>
                ),
            },
        ];

        if (role !== 'User') {
            cols.unshift({
                field: 'select', headerName: '', width: 50, sortable: false, disableColumnMenu: true, filterable: false,
                renderHeader: () => {
                    const allSelected = challanRows.length > 0 && challanRows.every(r => challanSelectionModel.includes(Number(r.ChallanAutoID)));
                    const someSelected = challanSelectionModel.length > 0 && !allSelected;
                    return (
                        <Checkbox
                            checked={allSelected}
                            indeterminate={someSelected}
                            onChange={(e) => setChallanSelectionModel(e.target.checked ? challanRows.map(r => Number(r.ChallanAutoID)) : [])}
                        />
                    );
                },
                renderCell: ({ row }) => (
                    <Checkbox
                        checked={challanSelectionModel.includes(Number(row.ChallanAutoID))}
                        onChange={(e) => {
                            const checked = e.target.checked;
                            setChallanSelectionModel(prev =>
                                checked
                                    ? [...prev, Number(row.ChallanAutoID)]
                                    : prev.filter(id => id !== Number(row.ChallanAutoID))
                            );
                        }}
                    />
                ),
            });

            cols.push({
                field: 'delete', headerName: 'Delete', flex: 0.6, align: 'right', headerAlign: 'right', filterable: false,
                renderCell: (params) => {
                    const rowId = Number(params.row.ChallanAutoID);
                    const isRowSelected = challanSelectionModel.includes(rowId);

                    return (
                        <Tooltip title={isRowSelected ? 'Delete this challan' : 'Select this row to delete'}>
                            <span>
                                <IconButton
                                    color="error"
                                    size="small"
                                    disabled={!isRowSelected}
                                    onClick={() => handleChallanDelete(challanSelectionModel)}
                                >
                                    <DeleteIcon />
                                </IconButton>
                            </span>
                        </Tooltip>
                    );
                },
            });
        }
        return cols;
    }, [challanRows, challanSelectionModel, role, navigate]);

    const openFilterPopup = useCallback(() => {
        const { from, to } = getFinancialYearRange(new Date());
        const fromDate = filterPopupFromDate || from;
        const toDate = filterPopupToDate || to;
        if (!filterPopupFromDate) setFilterPopupFromDate(fromDate);
        if (!filterPopupToDate) setFilterPopupToDate(toDate);
        setFilterPopupSnapshot({ mode: filterPopupMode, fromDate, toDate, firms: filterPopupFirms, series: filterPopupSeries });
        setFilterPopupOpen(true);
    }, [filterPopupFromDate, filterPopupToDate, filterPopupMode, filterPopupFirms, filterPopupSeries]);

    const cancelFilterPopup = useCallback(() => {
        if (filterPopupSnapshot) {
            setFilterPopupMode(filterPopupSnapshot.mode);
            setFilterPopupFromDate(filterPopupSnapshot.fromDate);
            setFilterPopupToDate(filterPopupSnapshot.toDate);
            setFilterPopupFirms(filterPopupSnapshot.firms || []);
            setFilterPopupSeries(filterPopupSnapshot.series || []);
        }
        setFilterPopupOpen(false);
    }, [filterPopupSnapshot]);

    const handleFilterOk = useCallback(async () => {
        setExportExcelEnabled(true);
        // setFilterPopupOpen(false);  // Keep popup open

        if (!companyId) {
            setSnackbarOpen(true);
            setSnackbarMessage('Company not selected');
            setSnackbarSeverity('warning');
            return;
        }

        if (!filterPopupFromDate || !filterPopupToDate) {
            setSnackbarOpen(true);
            setSnackbarMessage('Please select date range');
            setSnackbarSeverity('warning');
            return;
        }

        setReportLoading(true);

        try {
            // ── Prepare filter params ─────────────────────────────────
            const filterParams = {
                companyId,
                fromDate: filterPopupFromDate,
                toDate: filterPopupToDate,
                mode: filterPopupMode,
                // ✅ Send as comma-separated string or leave empty
                firms: filterPopupFirms.length > 0
                    ? filterPopupFirms.map(f => f.id).join(',')
                    : '',
                series: filterPopupSeries.length > 0
                    ? filterPopupSeries.map(s => s.id).join(',')
                    : '',
            };

            // ── Call single API ───────────────────────────────────────
            const response = await axios.get(
                `${API_URL}/sale-challan-register`,
                { params: filterParams }
            );

            const masterData = response?.data?.master?.data || [];
            const detailsData = response?.data?.details?.data || [];

            setMasterReportData(masterData);
            setDetailsReportData(detailsData);

            setSnackbarOpen(true);
            setSnackbarMessage(`Report loaded: ${masterData.length} master records, ${detailsData.length} detail records`);
            setSnackbarSeverity('success');

            console.log('Master Report Data:', masterData);
            console.log('Details Report Data:', detailsData);

        } catch (err) {
            console.error('Error fetching report data:', err);
            setSnackbarOpen(true);
            setSnackbarMessage(err?.response?.data?.message || 'Failed to fetch report data');
            setSnackbarSeverity('error');
        } finally {
            setReportLoading(false);
        }
    }, [
        companyId,
        filterPopupFromDate,
        filterPopupToDate,
        filterPopupMode,
        filterPopupFirms,
        filterPopupSeries,
        API_URL
    ]);

    const handleExportExcel = useCallback(() => {
        if (!masterReportData.length && !detailsReportData.length) {
            setSnackbarOpen(true);
            setSnackbarMessage('No data to export. Please apply filters first.');
            setSnackbarSeverity('warning');
            return;
        }

        const formatDate = (val) => {
            if (!val) return '';
            const s = String(val).split('T')[0]; // strip time if present
            if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
                const [y, m, d] = s.split('-');
                return `${d}-${m}-${y}`;
            }
            return val;
        };

        const buildSheet = (data, columns) => {
            const header = columns.map(c => c.header);
            const rows = data.map(row =>
                columns.map(c => {
                    const val = row[c.key] ?? '';
                    if (c.isDate) return formatDate(val);
                    if (val === 0 || val === '0' || val === 0.0) return '';
                    // Numeric columns often arrive from the API as strings (e.g. SQL
                    // DECIMAL fields serialized as text). aoa_to_sheet writes cells
                    // based on the JS value's type, so a string here becomes a text
                    // cell that Excel's status bar (Sum/Average) will not aggregate.
                    // Coerce to a real number so these columns total correctly.
                    if (c.isNumeric) {
                        const num = Number(val);
                        return Number.isNaN(num) ? val : num;
                    }
                    return val;
                })
            );
            return XLSX.utils.aoa_to_sheet([header, ...rows]);
        };

        // Master: Categoryid & BasicAmt removed; state→State; GSTRate placed before CGSTAmt; TransactionType removed
        const masterColumns = [
            { key: 'ChallanDate', header: 'BillDate', isDate: true },
            { key: 'ChallanNumber', header: 'BillNumber' },
            { key: 'FirmName', header: 'FirmName' },
            { key: 'GSTNo', header: 'GSTNo' },
            { key: 'state', header: 'State' },
            { key: 'StateCode', header: 'StateCode' },
            { key: 'TransactionType', header: 'TransactionType' },
            { key: 'GSTRate', header: 'GSTRate', isNumeric: true },
            { key: 'TaxableAmt', header: 'TaxableAmt', isNumeric: true },
            { key: 'CGSTAmt', header: 'CGSTAmt', isNumeric: true },
            { key: 'SGSTAmt', header: 'SGSTAmt', isNumeric: true },
            { key: 'IGSTAmt', header: 'IGSTAmt', isNumeric: true },
            { key: 'UTGSTAmt', header: 'UTGSTAmt', isNumeric: true },
            { key: 'GSTCEssAmt', header: 'GSTCessAmt', isNumeric: true },
            { key: 'BillAmt', header: 'BillAmt', isNumeric: true },
            { key: 'EwayBillNumber', header: 'EwayBillNumber' },
            { key: 'Remark', header: 'Remark' },
        ];

        // Details: exact sequence specified; state→State, itemCode→ItemCode, description→Description, QTY→Qty; TransactionType removed
        const detailsColumns = [
            { key: 'ChallanDate', header: 'BillDate', isDate: true },
            { key: 'ChallanNumber', header: 'BillNumber' },
            { key: 'FirmName', header: 'FirmName' },
            { key: 'GSTNo', header: 'GSTNo' },
            { key: 'state', header: 'State' },
            { key: 'StateCode', header: 'StateCode' },
            { key: 'TransactionType', header: 'TransactionType' },
            { key: 'itemCode', header: 'ItemCode' },
            { key: 'description', header: 'Description' },
            { key: 'HSNNo', header: 'HSNNo' },
            { key: 'Unit', header: 'Unit' },
            { key: 'QTY', header: 'Qty', isNumeric: true },
            { key: 'Rate', header: 'Rate', isNumeric: true },
            { key: 'Disc', header: 'Disc', isNumeric: true },
            { key: 'TaxableAmt', header: 'TaxableAmt', isNumeric: true },
            { key: 'GSTRate', header: 'GSTRate', isNumeric: true },
            { key: 'CGSTRate', header: 'CGSTRate', isNumeric: true },
            { key: 'SGSTRate', header: 'SGSTRate', isNumeric: true },
            { key: 'IGSTRate', header: 'IGSTRate', isNumeric: true },
            { key: 'CESSRate', header: 'CESSRate', isNumeric: true },
            { key: 'UTGSTRate', header: 'UTGSTRate', isNumeric: true },
            { key: 'CGSTAmt', header: 'CGSTAmt', isNumeric: true },
            { key: 'SGSTAmt', header: 'SGSTAmt', isNumeric: true },
            { key: 'IGSTAmt', header: 'IGSTAmt', isNumeric: true },
            { key: 'CESSAmt', header: 'CESSAmt', isNumeric: true },
            { key: 'UTGSTAmt', header: 'UTGSTAmt', isNumeric: true },
            { key: 'ItemRemark', header: 'ItemRemark' },
        ];

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, buildSheet(masterReportData, masterColumns), 'Master');
        XLSX.utils.book_append_sheet(wb, buildSheet(detailsReportData, detailsColumns), 'Details');

        const fromDate = filterPopupFromDate || 'start';
        const toDate = filterPopupToDate || 'end';
        XLSX.writeFile(wb, `SaleChallanRegister_${fromDate}_${toDate}.xlsx`);

        setSnackbarOpen(true);
        setSnackbarMessage('Excel exported successfully!');
        setSnackbarSeverity('success');
    }, [masterReportData, detailsReportData, filterPopupFromDate, filterPopupToDate]);

    useEffect(() => {
        if (!filterPopupOpen) return;
        if (!API_URL || !companyId) return;
        let active = true;
        const fetchAllFirms = async () => {
            try {
                setFirmLoading(true);
                const res = await axios.get(`${API_URL}/company-search`, { params: { field: 'FirmName', search: '', companyId, limit: 1000 } });
                const data = Array.isArray(res?.data?.data) ? res.data.data : [];
                if (!active) return;
                const opts = data.map(r => ({ id: r?.id, label: r?.FirmName || '' })).filter(o => o.label);
                setFirmAllOptions(opts);
                if (!(firmInputValue || '').trim()) setFirmOptions(opts);
            } catch (err) {
                if (!active) return;
                setFirmAllOptions([]);
                setFirmOptions([]);
            } finally {
                if (active) setFirmLoading(false);
            }
        };
        fetchAllFirms();
        return () => { active = false; };
    }, [companyId, API_URL, filterPopupOpen]);

    useEffect(() => {
        if (!(firmInputValue || '').trim()) {
            setFirmOptions(firmAllOptions);
            return;
        }
        const q = firmInputValue.toLowerCase();
        setFirmOptions(firmAllOptions.filter(o => o.label.toLowerCase().includes(q)));
    }, [firmInputValue, firmAllOptions]);

    useEffect(() => {
        if (!filterPopupOpen) return;
        if (!companyId) return;
        let active = true;
        const fetchSeries = async () => {
            try {
                setSeriesLoading(true);
                const { data } = await axios.get(`${API_URL}/bookmaster-series`, {
                    params: { companyId, bookTypeName: 'Sale Challan - Sale Invoice' }
                });
                if (!active) return;
                setSeriesOptions(Array.isArray(data) ? data.map(item => ({ id: item?.BookMastID, label: item?.SeriesName })) : []);
            } catch (err) {
                if (active) setSeriesOptions([]);
            } finally {
                if (active) setSeriesLoading(false);
            }
        };
        fetchSeries();
        return () => { active = false; };
    }, [companyId, API_URL, filterPopupOpen]);

    return (
        <Box sx={{ pt: 0.7, px: { xs: 2, sm: 3, md: 4 } }}>
            {/* Header */}

            {/* ── Module Header ──────────────────────────────────────────────
                If sale order rows are selected, the Add button creates a
                Sale Challan from those orders; else opens a blank form.
            ────────────────────────────────────────────────────────────────── */}
            <Box sx={{ mb: 2 }}>
                <Box sx={{ height: 4, background: gradients.primaryRow, borderRadius: '6px 6px 0 0' }} />
                <Paper elevation={0} sx={{ border: '1px solid', borderColor: 'divider', borderTop: 0, borderRadius: '0 0 8px 8px', px: 2, py: 1.2, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Typography variant="h6" fontWeight={700} color="primary.main" sx={{ fontSize: '1.05rem' }}>
                        Sale Challans
                    </Typography>
                    <Box sx={{ display: 'flex', gap: 1 }}>
                        <Button variant="outlined" size="small" startIcon={<FilterAltIcon />} onClick={openFilterPopup} sx={{ textTransform: 'none' }}>Filter</Button>
                        {/* "Show Orders"/"Hide Orders" — only for the "Accounting" plan.
                            "Billing" plan companies never see Sale Orders, so hide it there. */}
                        {/* {selectedCompany?.planName !== 'Billing' && (
                            <Button variant="outlined" size="small" onClick={() => setShowPending(!showPending)} sx={{ textTransform: 'none' }}>
                                {showPending ? 'Hide Orders' : 'Show Orders'}
                            </Button>
                        )} */}
                        {/* If sale order rows are selected → create challan from them; else open blank form */}
                        <Button variant="contained" size="small" startIcon={<AddIcon />}
                            onClick={() => {
                                if (selectedRows.length > 0) {
                                    handleDispatch();
                                } else {
                                    navigate("/main/v3/challanMaster-stepper");
                                }
                            }}
                        >
                            {isSmallDevice ? 'Add' : 'Add Challan'}
                        </Button>
                    </Box>
                </Paper>
            </Box>
            <Paper elevation={3} sx={{ borderRadius: 2, overflow: 'hidden', width: '100%' }}>
                <Box sx={{ p: { xs: 0.5, md: 0.5 } }}>
                    {/* Search (mobile only) */}
                    {!isDesktop && (
                        <Box sx={{ mb: 3 }}>
                            <TextField
                                fullWidth
                                size="small"
                                placeholder="Search by number or client..."
                                value={filterText}
                                onChange={(e) => setFilterText(e.target.value)}
                                InputProps={{
                                    startAdornment: <InputAdornment position="start"><SearchIcon /></InputAdornment>,
                                }}
                            />
                        </Box>
                    )}

                    {!isDesktop && role !== 'User' && challanSelectionModel.length > 0 && (
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                px: 2,
                                py: 1.5,
                                mb: 2,
                                bgcolor: 'background.paper',
                                borderRadius: 2,
                                boxShadow: 1
                            }}
                        >
                            <Box display="flex" alignItems="center">
                                <Checkbox
                                    checked={
                                        filteredChallans.length > 0 &&
                                        filteredChallans.every(r =>
                                            challanSelectionModel.includes(Number(r.ChallanAutoID))
                                        )
                                    }
                                    onChange={() => {
                                        const allSelected =
                                            filteredChallans.length > 0 &&
                                            filteredChallans.every(r =>
                                                challanSelectionModel.includes(Number(r.ChallanAutoID))
                                            );

                                        if (allSelected) {
                                            setChallanSelectionModel([]);
                                        } else {
                                            setChallanSelectionModel(
                                                filteredChallans.map(r => Number(r.ChallanAutoID))
                                            );
                                        }
                                    }}
                                />

                                <Typography>
                                    {challanSelectionModel.length} selected
                                </Typography>
                            </Box>

                            <IconButton
                                color="error"
                                onClick={() => handleChallanDelete(challanSelectionModel)}
                            >
                                <DeleteIcon />
                            </IconButton>
                        </Box>
                    )}

                    {/* Pending Orders Section */}
                    {showPending && (
                        <Paper elevation={2} sx={{ borderRadius: 3, p: 1.5, overflow: 'auto', mb: 2.5 }}>
                            <Grid container justifyContent="space-between" alignItems="center" mb={1.5}>
                                <Typography variant="h6" fontWeight={600}> My Orders</Typography>
                                {/* {selectedRows.length > 0 && (
                                <Button variant="contained" color="primary" onClick={handleDispatch} size='small'>
                                    Go To Dispatch
                                </Button>
                            )} */}
                            </Grid>

                            <Box sx={{ height: isDesktop ? '71vh' : "", width: '100%', position: 'relative' }}>
                                {isDesktop ? (<>
                                    <LoadingOverlay isVisible={showLoadingSpinner} />
                                    {showPendingEmpty && <NoDataComponent />}
                                    {!showLoadingSpinner && !showPendingEmpty && (
                                        <DataGrid
                                            rows={pendingOrders}
                                            columns={columns}
                                            getRowId={(row) => String(row.SOId)}
                                            initialState={{ pagination: { paginationModel: { pageSize: 50, page: 0 } } }}
                                            pageSizeOptions={[50, 100]}
                                            getRowHeight={() => 'auto'}
                                            sx={{
                                                '& .MuiDataGrid-columnHeaders': { backgroundColor: themeColors.neutral.gridHeader, borderBottom: `1px solid ${themeColors.neutral.border}` },
                                                '& .MuiDataGrid-columnHeaderTitle': { fontWeight: 700 },
                                                '& .MuiDataGrid-columnHeader': { backgroundColor: themeColors.neutral.gridHeader, color: themeColors.neutral.ink, fontWeight: 700, fontSize: '0.74rem', textTransform: 'uppercase', letterSpacing: '0.06em' },

                                                // Background styling
                                                '& .MuiDataGrid-filler': { backgroundColor: themeColors.neutral.surface },
                                                '& .MuiDataGrid-scrollbarFiller': { backgroundColor: themeColors.neutral.gridHeader },

                                                // Row styling
                                                '& .MuiDataGrid-row:nth-of-type(odd)': { backgroundColor: themeColors.neutral.surface },
                                                '& .MuiDataGrid-row:nth-of-type(even)': { backgroundColor: themeColors.neutral.surfaceAlt },
                                                '& .MuiDataGrid-row:hover': { backgroundColor: themeColors.primary.tint },

                                                // Selected row styling (with !important to override default MUI)
                                                '& .MuiDataGrid-row.Mui-selected': { backgroundColor: `${themeColors.primary.selected} !important` },

                                                // Cell content alignment
                                                '& .MuiDataGrid-cell': {
                                                    display: 'flex',
                                                    alignItems: 'center'
                                                },
                                            }}
                                            slots={{
                                                noResultsOverlay: CustomNoDataOverlay
                                            }}
                                        />
                                    )}
                                </>
                                ) : (
                                    <Box sx={{ px: 1 }}>
                                        {showPendingSpinner && <SkeletonLoader count={3} height={120} />}
                                        {showPendingEmpty && <NoDataComponent />}
                                        {!showPendingSpinner && !showPendingEmpty && renderPendingOrderCards()}
                                    </Box>
                                )}
                            </Box>
                        </Paper>
                    )}

                    {/* Challan List */}
                    <Paper elevation={3} sx={{ borderRadius: 3, p: 0.5, overflow: 'hidden', display: isDesktop || !showPending ? 'block' : 'none' }} >
                        {/* <Box sx={{ p: { xs: 2, md: 3 } }}> */}

                        {/* {!showPending &&
                            <Box display='flex' justifyContent='space-between' alignItems='center' mb={1.5}>
                                <Typography variant='h6' fontWeight={600}>Challan List</Typography>
                            </Box>} */}

                        {isDesktop ? (
                            <Box sx={{ height: '71vh', width: '100%', position: 'relative' }}>
                                <LoadingOverlay isVisible={showChallanSpinner} />
                                {showChallanEmpty && <NoDataComponent />}
                                {!showChallanSpinner && !showChallanEmpty && (
                                    <DataGrid
                                        rows={challanRows}
                                        getRowHeight={() => 'auto'}
                                        getRowId={(row) => row.ChallanAutoID}
                                        columns={challanColumns}
                                        pageSizeOptions={[50, 100]}
                                        disableRowSelectionOnClick
                                        sx={{
                                            '& .MuiDataGrid-columnHeaders': { backgroundColor: themeColors.neutral.gridHeader, borderBottom: `1px solid ${themeColors.neutral.border}` },
                                            '& .MuiDataGrid-columnHeaderTitle': { fontWeight: 700 },
                                            '& .MuiDataGrid-columnHeader': { backgroundColor: themeColors.neutral.gridHeader, color: themeColors.neutral.ink, fontWeight: 700, fontSize: '0.74rem', textTransform: 'uppercase', letterSpacing: '0.06em' },

                                            // Background styling
                                            '& .MuiDataGrid-filler': { backgroundColor: themeColors.neutral.surface },
                                            '& .MuiDataGrid-scrollbarFiller': {
                                                backgroundColor: themeColors.primary.surface,
                                            },

                                            // Row styling
                                            '& .MuiDataGrid-row:nth-of-type(odd)': {
                                                backgroundColor: themeColors.neutral.surface,
                                            },
                                            '& .MuiDataGrid-row:nth-of-type(even)': {
                                                backgroundColor: themeColors.neutral.surfaceAlt,
                                            },
                                            '& .MuiDataGrid-row:hover': {
                                                backgroundColor: themeColors.primary.tint,
                                            },

                                            // Selected row styling
                                            '& .MuiDataGrid-row.Mui-selected': {
                                                backgroundColor: `${themeColors.primary.selected} !important`,
                                            },

                                            // Cell alignment
                                            '& .MuiDataGrid-cell': {
                                                display: 'flex',
                                                alignItems: 'center',
                                            },
                                        }}
                                        slots={{
                                            noResultsOverlay: CustomNoDataOverlay
                                        }}
                                    />
                                )}
                            </Box>
                        ) : (
                            !showPending && (
                                <Box sx={{ px: 1 }}>
                                    {showChallanSpinner && <SkeletonLoader count={3} height={120} />}
                                    {showChallanEmpty && <NoDataComponent />}
                                    {!showChallanSpinner && !showChallanEmpty && renderChallanCards()}
                                </Box>
                            )
                        )}
                        {/* </Box> */}
                    </Paper>
                </Box>
            </Paper>

            {/* PDF Viewer / Status */}
            {pdfError && <Alert severity="error" sx={{ mt: 2 }}>PDF Error: {pdfError}</Alert>}
            {pdfLoading && (
                <motion.div
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.3 }}
                    style={{ marginTop: 16, display: "flex", alignItems: "center", gap: 8 }}
                >
                    <motion.div
                        animate={{ rotate: 360 }}
                        transition={{ duration: 1.4, repeat: Infinity, ease: "linear" }}
                        style={{
                            width: 18,
                            height: 18,
                            borderRadius: '50%',
                            border: `2px solid ${themeColors.neutral.line}`,
                            borderTopColor: '#3b82f6',
                        }}
                    />
                    <Typography sx={{ fontSize: '0.9rem', color: '#6b7280', fontWeight: 500 }}>Preparing PDF...</Typography>
                </motion.div>
            )}
            {pdfUri && <Box sx={{ mt: 2 }}><PdfViewer uri={pdfUri} /></Box>}

            {/* Overlay */}
            {pdfOverlayVisible && (
                <Box sx={{ position: "fixed", inset: 0, bgcolor: "rgba(0,0,0,0.92)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 9999, backdropFilter: "blur(4px)" }}>
                    <Box sx={{ textAlign: "center", bgcolor: "#111", p: "40px 60px", borderRadius: "20px" }}>
                        <CircularProgress size={60} thickness={4} sx={{ color: themeColors.neutral.surface }} />
                        <Typography variant="h6" sx={{ color: themeColors.neutral.surface, mt: 3, fontWeight: 600 }}>Generating Challan PDF…</Typography>
                        <Typography variant="body2" sx={{ color: themeColors.neutral.muted, mt: 1 }}>Please wait</Typography>
                    </Box>
                </Box>
            )}

            <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={() => setSnackbarOpen(false)} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
                <Alert onClose={() => setSnackbarOpen(false)} severity={snackbarSeverity} variant="filled">
                    {snackbarMessage}
                </Alert>
            </Snackbar>

            {/* ── Delete Confirmation Dialog ──────────────────────────── */}
            <Dialog open={openDeleteDialog} onClose={() => { if (!deleting) setOpenDeleteDialog(false); }} maxWidth="xs" fullWidth>
                {deleting
                    ? <LinearProgress color="error" sx={{ height: 4 }} />
                    : <Box sx={{ height: 4, background: gradients.danger }} />}
                <Box sx={{ px: 2.5, pt: 2, pb: 1.5 }}>
                    <Typography variant="h6" fontWeight={700} sx={{ color: 'error.main', fontSize: '1.05rem' }}>Confirm Deletion</Typography>
                </Box>
                <Divider />
                <Box sx={{ px: 2.5, py: 2 }}>
                    <Typography variant="body2" color="text.secondary">
                        Are you sure you want to delete{' '}
                        <Typography component="span" variant="body2" fontWeight={700} color="error.main">{pendingDeleteIds.length}</Typography>
                        {' '}challan(s)? This action cannot be undone.
                    </Typography>
                </Box>
                <Divider />
                <Box sx={{ px: 2.5, py: 1.5, display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                    <Button onClick={() => setOpenDeleteDialog(false)} variant="outlined" color="inherit" size="small" disabled={deleting}>Cancel</Button>
                    <Button color="error" variant="contained" size="small" disabled={deleting}
                        startIcon={deleting ? <CircularProgress size={14} color="inherit" /> : <DeleteIcon />}
                        onClick={confirmChallanDelete}>{deleting ? 'Deleting…' : 'Delete'}</Button>
                </Box>
            </Dialog>

            <Menu
                anchorEl={menuAnchorEl}
                open={Boolean(menuAnchorEl)}
                onClose={handleMenuClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
            >
                <MenuItem onClick={handleEwayBillFromMenu}>
                    E-Way Bill
                </MenuItem>
            </Menu>

            {/* Dialog for e-way bill */}
            <Dialog
                open={ewayDialogOpen}
                onClose={(event, reason) => { if (reason === 'backdropClick') return; closeEwayDialog(); }}   // ← use new handler (a click outside the popup does not close it)
                maxWidth="md"
                fullWidth
                PaperProps={{
                    sx: { borderRadius: 2, maxWidth: 700 }
                }}
            >
                <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pb: 0 }}>
                    E-Way Bill
                    <IconButton onClick={closeEwayDialog} size="small">
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent sx={{ p: 0 }}>
                    {ewayDialogMounted && (
                        <EwayBillMaster
                            connectionString={connectionString}
                            invoiceId={ewayInvoiceId}
                            bookName={ewayBookName}
                        />
                    )}
                </DialogContent>
            </Dialog>

            {/* Filter Dialog */}
            <Dialog
                open={filterPopupOpen}
                onClose={cancelFilterPopup}
                fullWidth
                maxWidth="sm"
                PaperProps={{ sx: { borderRadius: 2, boxShadow: '0 4px 20px rgba(0,0,0,0.1)' } }}
            >
                {/* Header */}
                <DialogTitle
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        pb: 1.5,
                        pt: 2,
                        px: 3,
                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                        color: 'white'
                    }}
                >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                        <Box
                            sx={{
                                bgcolor: 'rgba(255,255,255,0.2)',
                                borderRadius: '50%',
                                p: 0.8,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                        >
                            <FilterListIcon sx={{ color: 'white', fontSize: 20 }} />
                        </Box>
                        <Typography variant="h6" fontWeight={600} sx={{ fontSize: '1.1rem' }}>
                            Filter Options
                        </Typography>
                    </Box>
                    <IconButton
                        onClick={cancelFilterPopup}
                        size="small"
                        sx={{
                            color: 'white',
                            bgcolor: 'rgba(255,255,255,0.15)',
                            '&:hover': { bgcolor: 'rgba(255,255,255,0.25)' }
                        }}
                    >
                        <CloseIcon fontSize="small" />
                    </IconButton>
                </DialogTitle>

                <DialogContent sx={{ px: 3, py: 2, bgcolor: themeColors.neutral.surfaceAlt }}>
                    {/* Filter Mode Selection */}
                    <Paper
                        elevation={0}
                        sx={{
                            p: 2,
                            mb: 1,
                            mt: 1,
                            bgcolor: 'white',
                            border: `1px solid ${themeColors.neutral.line}`,
                            borderRadius: 2,
                            boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
                        }}
                    >
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                            <Box sx={{ width: 4, height: 20, bgcolor: 'primary.main', borderRadius: 1 }} />
                            <Typography variant="subtitle1" fontWeight={600} sx={{ color: 'text.primary' }}>
                                Filter Mode
                            </Typography>
                        </Box>
                        <RadioGroup
                            row
                            value={filterPopupMode}
                            onChange={(e) => setFilterPopupMode(e.target.value)}
                            sx={{ display: 'flex', gap: 2 }}
                        >
                            <FormControlLabel
                                value="datewise"
                                control={
                                    <Radio
                                        size="small"
                                        sx={{
                                            '&.Mui-checked': { color: 'primary.main' }
                                        }}
                                    />
                                }
                                label={
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                        <Typography variant="body2" fontWeight={500}>
                                            📅 Date Wise
                                        </Typography>
                                    </Box>
                                }
                                sx={{
                                    flex: 1,
                                    m: 0,
                                    bgcolor: filterPopupMode === 'datewise' ? themeColors.primary.tint : themeColors.neutral.surfaceMuted,
                                    borderRadius: 1.5,
                                    px: 2,
                                    py: 0.5,
                                    border: filterPopupMode === 'datewise' ? '2px solid' : '2px solid transparent',
                                    borderColor: 'primary.main',
                                    transition: 'all 0.3s ease',
                                    '&:hover': {
                                        bgcolor: filterPopupMode === 'datewise' ? themeColors.primary.tint : themeColors.neutral.border,
                                    }
                                }}
                            />
                            <FormControlLabel
                                value="partywise"
                                control={
                                    <Radio
                                        size="small"
                                        sx={{
                                            '&.Mui-checked': { color: 'primary.main' }
                                        }}
                                    />
                                }
                                label={
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                        <Typography variant="body2" fontWeight={500}>
                                            👥 Party Wise
                                        </Typography>
                                    </Box>
                                }
                                sx={{
                                    flex: 1,
                                    m: 0,
                                    bgcolor: filterPopupMode === 'partywise' ? themeColors.primary.tint : themeColors.neutral.surfaceMuted,
                                    borderRadius: 1.5,
                                    px: 2,
                                    py: 0.5,
                                    border: filterPopupMode === 'partywise' ? '2px solid' : '2px solid transparent',
                                    borderColor: 'primary.main',
                                    transition: 'all 0.3s ease',
                                    '&:hover': {
                                        bgcolor: filterPopupMode === 'partywise' ? themeColors.primary.tint : themeColors.neutral.border,
                                    }
                                }}
                            />
                        </RadioGroup>
                    </Paper>

                    {/* Filter Fields */}
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                        {/* Date Range */}
                        <Paper
                            elevation={0}
                            sx={{
                                p: 2,
                                bgcolor: 'white',
                                border: `1px solid ${themeColors.neutral.line}`,
                                borderRadius: 2,
                                boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
                            }}
                        >
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                                <Box sx={{ width: 4, height: 20, bgcolor: '#ff6b6b', borderRadius: 1 }} />
                                <Typography variant="subtitle2" fontWeight={600} sx={{ color: 'text.primary' }}>
                                    📆 Date Range
                                </Typography>
                            </Box>
                            <Box sx={{ display: 'flex', gap: 2 }}>
                                <Box sx={{ flex: 1 }}>
                                    <Typography
                                        variant="caption"
                                        fontWeight={600}
                                        sx={{ mb: 0.5, display: 'block', color: 'text.secondary' }}
                                    >
                                        From Date
                                    </Typography>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        type="date"
                                        value={filterPopupFromDate}
                                        onChange={(e) => setFilterPopupFromDate(e.target.value)}
                                        InputLabelProps={{ shrink: true }}
                                        sx={{
                                            '& .MuiInputBase-root': {
                                                bgcolor: themeColors.neutral.surfaceAlt,
                                                borderRadius: 1.5,
                                                '&:hover': { bgcolor: themeColors.neutral.surfaceMuted },
                                                '&.Mui-focused': { bgcolor: 'white' }
                                            },
                                            '& .MuiOutlinedInput-notchedOutline': { borderColor: themeColors.neutral.line }
                                        }}
                                    />
                                </Box>
                                <Box sx={{ flex: 1 }}>
                                    <Typography
                                        variant="caption"
                                        fontWeight={600}
                                        sx={{ mb: 0.5, display: 'block', color: 'text.secondary' }}
                                    >
                                        To Date
                                    </Typography>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        type="date"
                                        value={filterPopupToDate}
                                        onChange={(e) => setFilterPopupToDate(e.target.value)}
                                        InputLabelProps={{ shrink: true }}
                                        sx={{
                                            '& .MuiInputBase-root': {
                                                bgcolor: themeColors.neutral.surfaceAlt,
                                                borderRadius: 1.5,
                                                '&:hover': { bgcolor: themeColors.neutral.surfaceMuted },
                                                '&.Mui-focused': { bgcolor: 'white' }
                                            },
                                            '& .MuiOutlinedInput-notchedOutline': { borderColor: themeColors.neutral.line }
                                        }}
                                    />
                                </Box>
                            </Box>
                        </Paper>

                        {/* Firm Name */}
                        <Paper
                            elevation={0}
                            sx={{
                                p: 2,
                                bgcolor: 'white',
                                border: `1px solid ${themeColors.neutral.line}`,
                                borderRadius: 2,
                                boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
                            }}
                        >
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                                <Box sx={{ width: 4, height: 20, bgcolor: '#4ecdc4', borderRadius: 1 }} />
                                <Typography variant="subtitle2" fontWeight={600} sx={{ color: 'text.primary' }}>
                                    🏢 Firm Name
                                </Typography>
                            </Box>
                            <Autocomplete
                                multiple
                                options={firmOptions}
                                value={filterPopupFirms}
                                loading={firmLoading}
                                inputValue={firmInputValue}
                                onInputChange={(_, v) => setFirmInputValue(v)}
                                onChange={(_, v) => setFilterPopupFirms(v)}
                                getOptionLabel={(o) => o.label || ''}
                                isOptionEqualToValue={(o, v) => o.id === v.id}
                                renderTags={() => null}
                                renderOption={(props, option, { selected }) => (
                                    <li {...props}>
                                        <Checkbox
                                            checked={selected}
                                            size="small"
                                            sx={{
                                                mr: 1,
                                                color: '#4ecdc4',
                                                '&.Mui-checked': { color: '#4ecdc4' }
                                            }}
                                        />
                                        <Typography variant="body2">{option?.label || ''}</Typography>
                                    </li>
                                )}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        size="small"
                                        fullWidth
                                        placeholder={filterPopupFirms?.length ? `${filterPopupFirms.length} firm(s) selected` : 'Select firms (ALL)'}
                                        sx={{
                                            '& .MuiInputBase-root': {
                                                bgcolor: themeColors.neutral.surfaceAlt,
                                                borderRadius: 1.5,
                                                '&:hover': { bgcolor: themeColors.neutral.surfaceMuted },
                                                '&.Mui-focused': { bgcolor: 'white' }
                                            },
                                            '& .MuiOutlinedInput-notchedOutline': { borderColor: themeColors.neutral.line }
                                        }}
                                        InputProps={{
                                            ...params.InputProps,
                                            startAdornment: (
                                                <>
                                                    {filterPopupFirms?.length > 0 && (
                                                        <Chip
                                                            label={`${filterPopupFirms.length}`}
                                                            size="small"
                                                            sx={{
                                                                ml: 0.5,
                                                                height: 22,
                                                                bgcolor: '#4ecdc4',
                                                                color: 'white',
                                                                fontWeight: 700,
                                                                fontSize: '0.75rem'
                                                            }}
                                                        />
                                                    )}
                                                    {params.InputProps.startAdornment}
                                                </>
                                            ),
                                            endAdornment: (
                                                <>
                                                    {firmLoading ? <CircularProgress size={16} /> : null}
                                                    {params.InputProps.endAdornment}
                                                </>
                                            )
                                        }}
                                    />
                                )}
                                PaperComponent={(props) => <Paper elevation={4} {...props} />}
                                ListboxProps={{ style: { maxHeight: 200 } }}
                            />
                        </Paper>

                        {/* Series */}
                        <Paper
                            elevation={0}
                            sx={{
                                p: 2,
                                bgcolor: 'white',
                                border: `1px solid ${themeColors.neutral.line}`,
                                borderRadius: 2,
                                boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
                            }}
                        >
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                                <Box sx={{ width: 4, height: 20, bgcolor: '#a55eea', borderRadius: 1 }} />
                                <Typography variant="subtitle2" fontWeight={600} sx={{ color: 'text.primary' }}>
                                    📋 Series
                                </Typography>
                            </Box>
                            <Autocomplete
                                multiple
                                options={seriesOptions}
                                value={filterPopupSeries}
                                loading={seriesLoading}
                                onChange={(_, v) => setFilterPopupSeries(v)}
                                getOptionLabel={(o) => o.label || ''}
                                isOptionEqualToValue={(o, v) => o.id === v.id}
                                renderTags={() => null}
                                renderOption={(props, option, { selected }) => (
                                    <li {...props}>
                                        <Checkbox
                                            checked={selected}
                                            size="small"
                                            sx={{
                                                mr: 1,
                                                color: '#a55eea',
                                                '&.Mui-checked': { color: '#a55eea' }
                                            }}
                                        />
                                        <Typography variant="body2">{option?.label || ''}</Typography>
                                    </li>
                                )}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        size="small"
                                        fullWidth
                                        placeholder={filterPopupSeries?.length ? `${filterPopupSeries.length} series selected` : 'Select series (ALL)'}
                                        sx={{
                                            '& .MuiInputBase-root': {
                                                bgcolor: themeColors.neutral.surfaceAlt,
                                                borderRadius: 1.5,
                                                '&:hover': { bgcolor: themeColors.neutral.surfaceMuted },
                                                '&.Mui-focused': { bgcolor: 'white' }
                                            },
                                            '& .MuiOutlinedInput-notchedOutline': { borderColor: themeColors.neutral.line }
                                        }}
                                        InputProps={{
                                            ...params.InputProps,
                                            startAdornment: (
                                                <>
                                                    {filterPopupSeries?.length > 0 && (
                                                        <Chip
                                                            label={`${filterPopupSeries.length}`}
                                                            size="small"
                                                            sx={{
                                                                ml: 0.5,
                                                                height: 22,
                                                                bgcolor: '#a55eea',
                                                                color: 'white',
                                                                fontWeight: 700,
                                                                fontSize: '0.75rem'
                                                            }}
                                                        />
                                                    )}
                                                    {params.InputProps.startAdornment}
                                                </>
                                            ),
                                            endAdornment: (
                                                <>
                                                    {seriesLoading ? <CircularProgress size={16} /> : null}
                                                    {params.InputProps.endAdornment}
                                                </>
                                            )
                                        }}
                                    />
                                )}
                                PaperComponent={(props) => <Paper elevation={4} {...props} />}
                                ListboxProps={{ style: { maxHeight: 200 } }}
                            />
                        </Paper>
                    </Box>
                </DialogContent>

                <DialogActions
                    sx={{
                        px: 3,
                        py: 1.5,
                        bgcolor: themeColors.neutral.surfaceAlt,
                        borderTop: `1px solid ${themeColors.neutral.line}`,
                        gap: 2
                    }}
                >
                    <Button
                        onClick={cancelFilterPopup}
                        variant="outlined"
                        sx={{
                            flex: 1,
                            borderRadius: 2,
                            textTransform: 'none',
                            fontWeight: 600,
                            py: 1,
                            borderColor: themeColors.neutral.line,
                            color: 'text.secondary',
                            '&:hover': { borderColor: themeColors.neutral.muted, bgcolor: themeColors.neutral.surfaceMuted }
                        }}
                    >
                        ✕ Cancel
                    </Button>

                    {/* Export Excel Button */}
                    <Button
                        onClick={handleExportExcel}
                        variant="outlined"
                        disabled={!exportExcelEnabled}
                        sx={{
                            flex: 1, borderRadius: 2, textTransform: 'none', fontWeight: 600, py: 1.2,
                            borderColor: !exportExcelEnabled ? themeColors.neutral.line : themeColors.success.dark,
                            color: !exportExcelEnabled ? 'text.disabled' : themeColors.success.dark,
                            '&:hover': {
                                borderColor: themeColors.success.dark,
                                bgcolor: '#f1f8e9'
                            },
                            '&.Mui-disabled': {
                                borderColor: themeColors.neutral.line,
                                color: 'text.disabled'
                            }
                        }}
                    >
                        📊 Export Excel
                    </Button>

                    <Button
                        onClick={handleFilterOk}
                        variant="contained"
                        sx={{
                            flex: 1,
                            borderRadius: 2,
                            textTransform: 'none',
                            fontWeight: 600,
                            py: 1,
                            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                            boxShadow: '0 4px 12px rgba(102, 126, 234, 0.3)',
                            '&:hover': {
                                background: 'linear-gradient(135deg, #5568d3 0%, #63408a 100%)',
                                boxShadow: '0 6px 16px rgba(102, 126, 234, 0.4)'
                            }
                        }}
                    >
                        ✓ Apply Filters
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
}